// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/YekanBakhFaNum-VF.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.6 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.pointer-events-none {
  pointer-events: none;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.-bottom-20 {
  bottom: -5rem;
}
.-left-0 {
  left: -0px;
}
.-left-0\\.5 {
  left: -0.125rem;
}
.-left-3 {
  left: -0.75rem;
}
.-left-3\\.5 {
  left: -0.875rem;
}
.-left-\\[0\\.938rem\\] {
  left: -0.938rem;
}
.-left-\\[1\\.125rem\\] {
  left: -1.125rem;
}
.-right-\\[0\\.281rem\\] {
  right: -0.281rem;
}
.-right-\\[0\\.8rem\\] {
  right: -0.8rem;
}
.-right-\\[1\\.125rem\\] {
  right: -1.125rem;
}
.-top-0 {
  top: -0px;
}
.-top-0\\.5 {
  top: -0.125rem;
}
.-top-1 {
  top: -0.25rem;
}
.-top-1\\.5 {
  top: -0.375rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-3 {
  top: -0.75rem;
}
.-top-3\\.5 {
  top: -0.875rem;
}
.-top-4 {
  top: -1rem;
}
.-top-8 {
  top: -2rem;
}
.-top-\\[1\\.625rem\\] {
  top: -1.625rem;
}
.-top-\\[1\\.875rem\\] {
  top: -1.875rem;
}
.-top-px {
  top: -1px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-2\\.5 {
  bottom: 0.625rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-3\\.5 {
  bottom: 0.875rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-\\[unset\\] {
  bottom: unset;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-0\\.5 {
  left: 0.125rem;
}
.left-1 {
  left: 0.25rem;
}
.left-10 {
  left: 2.5rem;
}
.left-3 {
  left: 0.75rem;
}
.left-3\\.5 {
  left: 0.875rem;
}
.left-4 {
  left: 1rem;
}
.left-5 {
  left: 1.25rem;
}
.left-7 {
  left: 1.75rem;
}
.left-\\[0\\.938rem\\] {
  left: 0.938rem;
}
.left-\\[1\\.875rem\\] {
  left: 1.875rem;
}
.left-\\[calc\\(50\\%-4\\.6875rem\\)\\] {
  left: calc(50% - 4.6875rem);
}
.right-0 {
  right: 0px;
}
.right-\\[1\\.188rem\\] {
  right: 1.188rem;
}
.right-\\[1\\.875rem\\] {
  right: 1.875rem;
}
.right-\\[2\\.125rem\\] {
  right: 2.125rem;
}
.right-\\[calc\\(50\\%-1\\.406rem\\)\\] {
  right: calc(50% - 1.406rem);
}
.right-\\[calc\\(50\\%-5\\.281rem\\)\\] {
  right: calc(50% - 5.281rem);
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-10 {
  top: 2.5rem;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-3 {
  top: 0.75rem;
}
.top-3\\.5 {
  top: 0.875rem;
}
.top-4 {
  top: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.top-6 {
  top: 1.5rem;
}
.top-8 {
  top: 2rem;
}
.top-9 {
  top: 2.25rem;
}
.top-\\[1\\.625rem\\] {
  top: 1.625rem;
}
.top-\\[2\\.125rem\\] {
  top: 2.125rem;
}
.top-\\[2\\.938rem\\] {
  top: 2.938rem;
}
.top-\\[20\\%\\] {
  top: 20%;
}
.top-\\[calc\\(100\\%-36px\\)\\] {
  top: calc(100% - 36px);
}
.top-px {
  top: 1px;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-40 {
  z-index: 40;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[5\\] {
  z-index: 5;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-1\\.5 {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-2\\.5 {
  margin-left: 0.625rem;
  margin-right: 0.625rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-3\\.5 {
  margin-left: 0.875rem;
  margin-right: 0.875rem;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-\\[0\\.938rem\\] {
  margin-left: 0.938rem;
  margin-right: 0.938rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-2\\.5 {
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-3\\.5 {
  margin-top: 0.875rem;
  margin-bottom: 0.875rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.\\!mt-\\[1\\.375rem\\] {
  margin-top: 1.375rem !important;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-3\\.5 {
  margin-bottom: 0.875rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-\\[1\\.375rem\\] {
  margin-bottom: 1.375rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-2\\.5 {
  margin-left: 0.625rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-3\\.5 {
  margin-left: 0.875rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-7 {
  margin-left: 1.75rem;
}
.ml-\\[1\\.125rem\\] {
  margin-left: 1.125rem;
}
.ml-\\[1\\.375rem\\] {
  margin-left: 1.375rem;
}
.mr-0 {
  margin-right: 0px;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-10 {
  margin-right: 2.5rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-2\\.5 {
  margin-right: 0.625rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-3\\.5 {
  margin-right: 0.875rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mr-6 {
  margin-right: 1.5rem;
}
.mr-8 {
  margin-right: 2rem;
}
.mr-\\[0\\.313rem\\] {
  margin-right: 0.313rem;
}
.mr-auto {
  margin-right: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-11 {
  margin-top: 2.75rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-3\\.5 {
  margin-top: 0.875rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-9 {
  margin-top: 2.25rem;
}
.mt-\\[1\\.125rem\\] {
  margin-top: 1.125rem;
}
.mt-\\[1\\.375rem\\] {
  margin-top: 1.375rem;
}
.mt-\\[1\\.625rem\\] {
  margin-top: 1.625rem;
}
.mt-\\[1\\.875rem\\] {
  margin-top: 1.875rem;
}
.mt-\\[2\\.125rem\\] {
  margin-top: 2.125rem;
}
.mt-\\[3\\.25rem\\] {
  margin-top: 3.25rem;
}
.mt-auto {
  margin-top: auto;
}
.mt-px {
  margin-top: 1px;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.\\!block {
  display: block !important;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.\\!flex {
  display: flex !important;
}
.flex {
  display: flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-3 {
  height: 0.75rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[0\\.563rem\\] {
  height: 0.563rem;
}
.h-\\[1\\.375rem\\] {
  height: 1.375rem;
}
.h-\\[1\\.438rem\\] {
  height: 1.438rem;
}
.h-\\[1\\.563rem\\] {
  height: 1.563rem;
}
.h-\\[10\\.125rem\\] {
  height: 10.125rem;
}
.h-\\[13\\.438rem\\] {
  height: 13.438rem;
}
.h-\\[17mm\\] {
  height: 17mm;
}
.h-\\[18\\.125rem\\] {
  height: 18.125rem;
}
.h-\\[2\\.313rem\\] {
  height: 2.313rem;
}
.h-\\[2\\.375rem\\] {
  height: 2.375rem;
}
.h-\\[2\\.625rem\\] {
  height: 2.625rem;
}
.h-\\[2\\.688rem\\] {
  height: 2.688rem;
}
.h-\\[2\\.75rem\\] {
  height: 2.75rem;
}
.h-\\[2\\.875rem\\] {
  height: 2.875rem;
}
.h-\\[20mm\\] {
  height: 20mm;
}
.h-\\[26\\.25rem\\] {
  height: 26.25rem;
}
.h-\\[3\\.25rem\\] {
  height: 3.25rem;
}
.h-\\[3\\.375rem\\] {
  height: 3.375rem;
}
.h-\\[3\\.438rem\\] {
  height: 3.438rem;
}
.h-\\[30\\.313rem\\] {
  height: 30.313rem;
}
.h-\\[32\\.875rem\\] {
  height: 32.875rem;
}
.h-\\[5\\.625rem\\] {
  height: 5.625rem;
}
.h-\\[6\\.75rem\\] {
  height: 6.75rem;
}
.h-\\[60\\%\\] {
  height: 60%;
}
.h-\\[7\\.25rem\\] {
  height: 7.25rem;
}
.h-\\[9\\.375rem\\] {
  height: 9.375rem;
}
.h-\\[9\\.688rem\\] {
  height: 9.688rem;
}
.h-\\[calc\\(100\\%\\+1\\.625rem\\)\\] {
  height: calc(100% + 1.625rem);
}
.h-\\[calc\\(100\\%\\+2rem\\)\\] {
  height: calc(100% + 2rem);
}
.h-\\[calc\\(100vh-16\\.71rem\\)\\] {
  height: calc(100vh - 16.71rem);
}
.h-\\[calc\\(100vh-18\\.625rem\\)\\] {
  height: calc(100vh - 18.625rem);
}
.h-\\[calc\\(100vh-3\\.5rem\\)\\] {
  height: calc(100vh - 3.5rem);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-full {
  max-height: 100%;
}
.min-h-\\[10mm\\] {
  min-height: 10mm;
}
.min-h-\\[10rem\\] {
  min-height: 10rem;
}
.min-h-\\[13mm\\] {
  min-height: 13mm;
}
.min-h-\\[15mm\\] {
  min-height: 15mm;
}
.min-h-\\[20mm\\] {
  min-height: 20mm;
}
.min-h-\\[25rem\\] {
  min-height: 25rem;
}
.min-h-\\[31rem\\] {
  min-height: 31rem;
}
.min-h-\\[37rem\\] {
  min-height: 37rem;
}
.min-h-\\[60vh\\] {
  min-height: 60vh;
}
.min-h-screen {
  min-height: 100vh;
}
.w-0 {
  width: 0px;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-36 {
  width: 9rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[0\\.563rem\\] {
  width: 0.563rem;
}
.w-\\[1\\.375rem\\] {
  width: 1.375rem;
}
.w-\\[10\\%\\] {
  width: 10%;
}
.w-\\[10\\.125rem\\] {
  width: 10.125rem;
}
.w-\\[10\\.563rem\\] {
  width: 10.563rem;
}
.w-\\[11\\.438rem\\] {
  width: 11.438rem;
}
.w-\\[12\\%\\] {
  width: 12%;
}
.w-\\[12\\.625rem\\] {
  width: 12.625rem;
}
.w-\\[13\\%\\] {
  width: 13%;
}
.w-\\[15\\%\\] {
  width: 15%;
}
.w-\\[15\\.2\\%\\] {
  width: 15.2%;
}
.w-\\[15\\.4\\%\\] {
  width: 15.4%;
}
.w-\\[15mm\\] {
  width: 15mm;
}
.w-\\[16\\.063rem\\] {
  width: 16.063rem;
}
.w-\\[16\\.313rem\\] {
  width: 16.313rem;
}
.w-\\[16\\.5rem\\] {
  width: 16.5rem;
}
.w-\\[17\\%\\] {
  width: 17%;
}
.w-\\[17\\.6\\%\\] {
  width: 17.6%;
}
.w-\\[19\\%\\] {
  width: 19%;
}
.w-\\[19\\.7\\%\\] {
  width: 19.7%;
}
.w-\\[19\\.8\\%\\] {
  width: 19.8%;
}
.w-\\[2\\.375rem\\] {
  width: 2.375rem;
}
.w-\\[2\\.625rem\\] {
  width: 2.625rem;
}
.w-\\[2\\.688rem\\] {
  width: 2.688rem;
}
.w-\\[2\\.813rem\\] {
  width: 2.813rem;
}
.w-\\[2\\.875rem\\] {
  width: 2.875rem;
}
.w-\\[20\\.438rem\\] {
  width: 20.438rem;
}
.w-\\[23\\%\\] {
  width: 23%;
}
.w-\\[25\\%\\] {
  width: 25%;
}
.w-\\[27\\.5rem\\] {
  width: 27.5rem;
}
.w-\\[290mm\\] {
  width: 290mm;
}
.w-\\[3\\.25rem\\] {
  width: 3.25rem;
}
.w-\\[3\\.375rem\\] {
  width: 3.375rem;
}
.w-\\[3\\.438rem\\] {
  width: 3.438rem;
}
.w-\\[33\\.8\\%\\] {
  width: 33.8%;
}
.w-\\[35\\%\\] {
  width: 35%;
}
.w-\\[36\\.8\\%\\] {
  width: 36.8%;
}
.w-\\[40\\%\\] {
  width: 40%;
}
.w-\\[47\\%\\] {
  width: 47%;
}
.w-\\[47\\.5rem\\] {
  width: 47.5rem;
}
.w-\\[5\\.25rem\\] {
  width: 5.25rem;
}
.w-\\[53\\%\\] {
  width: 53%;
}
.w-\\[6\\.438rem\\] {
  width: 6.438rem;
}
.w-\\[60\\%\\] {
  width: 60%;
}
.w-\\[60mm\\] {
  width: 60mm;
}
.w-\\[65\\%\\] {
  width: 65%;
}
.w-\\[7\\.25rem\\] {
  width: 7.25rem;
}
.w-\\[7\\.625rem\\] {
  width: 7.625rem;
}
.w-\\[7\\.8\\%\\] {
  width: 7.8%;
}
.w-\\[75\\%\\] {
  width: 75%;
}
.w-\\[8\\%\\] {
  width: 8%;
}
.w-\\[8\\.125rem\\] {
  width: 8.125rem;
}
.w-\\[8\\.5\\%\\] {
  width: 8.5%;
}
.w-\\[8\\.75\\] {
  width: 8.75;
}
.w-\\[9\\.375rem\\] {
  width: 9.375rem;
}
.w-\\[9\\.688rem\\] {
  width: 9.688rem;
}
.w-\\[calc\\(100\\%\\+1\\.875rem\\)\\] {
  width: calc(100% + 1.875rem);
}
.w-\\[calc\\(100\\%\\+4px\\)\\] {
  width: calc(100% + 4px);
}
.w-\\[calc\\(100vw-1\\.875rem\\)\\] {
  width: calc(100vw - 1.875rem);
}
.w-\\[calc\\(100vw-3\\.75rem\\)\\] {
  width: calc(100vw - 3.75rem);
}
.w-\\[calc\\(100vw-8\\.813rem\\)\\] {
  width: calc(100vw - 8.813rem);
}
.w-\\[calc\\(50\\%-0\\.6875rem\\)\\] {
  width: calc(50% - 0.6875rem);
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-px {
  width: 1px;
}
.w-screen {
  width: 100vw;
}
.min-w-\\[1\\.25rem\\] {
  min-width: 1.25rem;
}
.min-w-\\[1\\.5rem\\] {
  min-width: 1.5rem;
}
.min-w-\\[11\\.25rem\\] {
  min-width: 11.25rem;
}
.min-w-\\[11\\.563rem\\] {
  min-width: 11.563rem;
}
.min-w-\\[11\\.688rem\\] {
  min-width: 11.688rem;
}
.min-w-\\[16\\.313rem\\] {
  min-width: 16.313rem;
}
.min-w-\\[16\\.5rem\\] {
  min-width: 16.5rem;
}
.min-w-\\[2\\.25rem\\] {
  min-width: 2.25rem;
}
.min-w-\\[2\\.375rem\\] {
  min-width: 2.375rem;
}
.min-w-\\[2\\.5rem\\] {
  min-width: 2.5rem;
}
.min-w-\\[2\\.75rem\\] {
  min-width: 2.75rem;
}
.min-w-\\[20\\.438rem\\] {
  min-width: 20.438rem;
}
.min-w-\\[290mm\\] {
  min-width: 290mm;
}
.min-w-\\[3\\.375rem\\] {
  min-width: 3.375rem;
}
.min-w-\\[40mm\\] {
  min-width: 40mm;
}
.min-w-\\[40px\\] {
  min-width: 40px;
}
.min-w-\\[5\\.25rem\\] {
  min-width: 5.25rem;
}
.min-w-\\[6\\.438rem\\] {
  min-width: 6.438rem;
}
.min-w-\\[7\\.25rem\\] {
  min-width: 7.25rem;
}
.min-w-\\[8\\.563rem\\] {
  min-width: 8.563rem;
}
.min-w-\\[9\\.563rem\\] {
  min-width: 9.563rem;
}
.max-w-\\[14rem\\] {
  max-width: 14rem;
}
.max-w-\\[15mm\\] {
  max-width: 15mm;
}
.max-w-\\[2\\.5rem\\] {
  max-width: 2.5rem;
}
.max-w-\\[20\\.438rem\\] {
  max-width: 20.438rem;
}
.max-w-\\[290mm\\] {
  max-width: 290mm;
}
.max-w-\\[33rem\\] {
  max-width: 33rem;
}
.max-w-\\[37\\.5rem\\] {
  max-width: 37.5rem;
}
.max-w-\\[40\\%\\] {
  max-width: 40%;
}
.max-w-\\[43\\.25rem\\] {
  max-width: 43.25rem;
}
.max-w-\\[43\\.75rem\\] {
  max-width: 43.75rem;
}
.max-w-\\[790px\\] {
  max-width: 790px;
}
.max-w-\\[90vw\\] {
  max-width: 90vw;
}
.max-w-\\[calc\\(100vw-7rem\\)\\] {
  max-width: calc(100vw - 7rem);
}
.max-w-\\[calc\\(100vw-9rem\\)\\] {
  max-width: calc(100vw - 9rem);
}
.max-w-full {
  max-width: 100%;
}
.flex-1 {
  flex: 1 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.flex-grow-\\[2\\] {
  flex-grow: 2;
}
.table-auto {
  table-layout: auto;
}
.border-collapse {
  border-collapse: collapse;
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.snap-x {
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.snap-start {
  scroll-snap-align: start;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-1\\.5 {
  column-gap: 0.375rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-2\\.5 {
  column-gap: 0.625rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-3\\.5 {
  column-gap: 0.875rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-x-7 {
  column-gap: 1.75rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-x-\\[1\\.125rem\\] {
  column-gap: 1.125rem;
}
.gap-x-\\[1\\.375rem\\] {
  column-gap: 1.375rem;
}
.gap-x-\\[1\\.625rem\\] {
  column-gap: 1.625rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-1\\.5 {
  row-gap: 0.375rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-2\\.5 {
  row-gap: 0.625rem;
}
.gap-y-5 {
  row-gap: 1.25rem;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-\\[0\\.188rem\\] > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.188rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.188rem * var(--tw-space-y-reverse));
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-\\[0\\.625rem\\] {
  border-radius: 0.625rem !important;
}
.\\!rounded-\\[0\\.813rem\\] {
  border-radius: 0.813rem !important;
}
.\\!rounded-xl {
  border-radius: 0.75rem !important;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[0\\.188rem\\] {
  border-radius: 0.188rem;
}
.rounded-\\[0\\.313rem\\] {
  border-radius: 0.313rem;
}
.rounded-\\[0\\.438rem\\] {
  border-radius: 0.438rem;
}
.rounded-\\[0\\.563rem\\] {
  border-radius: 0.563rem;
}
.rounded-\\[0\\.625rem\\] {
  border-radius: 0.625rem;
}
.rounded-\\[0\\.688rem\\] {
  border-radius: 0.688rem;
}
.rounded-\\[0\\.813rem\\] {
  border-radius: 0.813rem;
}
.rounded-\\[0\\.875rem\\] {
  border-radius: 0.875rem;
}
.rounded-\\[1\\.063rem\\] {
  border-radius: 1.063rem;
}
.rounded-\\[1\\.125rem\\] {
  border-radius: 1.125rem;
}
.rounded-\\[1\\.25rem\\] {
  border-radius: 1.25rem;
}
.rounded-\\[1\\.375rem\\] {
  border-radius: 1.375rem;
}
.rounded-\\[1\\.563rem\\] {
  border-radius: 1.563rem;
}
.rounded-\\[1\\.813rem\\] {
  border-radius: 1.813rem;
}
.rounded-\\[2\\.25rem\\] {
  border-radius: 2.25rem;
}
.rounded-\\[2\\.5rem\\] {
  border-radius: 2.5rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-3xl {
  border-bottom-right-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}
.rounded-b-\\[1\\.25rem\\] {
  border-bottom-right-radius: 1.25rem;
  border-bottom-left-radius: 1.25rem;
}
.rounded-b-\\[2\\.25rem\\] {
  border-bottom-right-radius: 2.25rem;
  border-bottom-left-radius: 2.25rem;
}
.rounded-b-\\[2\\.5rem\\] {
  border-bottom-right-radius: 2.5rem;
  border-bottom-left-radius: 2.5rem;
}
.rounded-b-none {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-b-xl {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-l-2xl {
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-l-3xl {
  border-top-left-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}
.rounded-l-\\[0\\.688rem\\] {
  border-top-left-radius: 0.688rem;
  border-bottom-left-radius: 0.688rem;
}
.rounded-l-\\[0\\.875rem\\] {
  border-top-left-radius: 0.875rem;
  border-bottom-left-radius: 0.875rem;
}
.rounded-l-\\[1\\.063rem\\] {
  border-top-left-radius: 1.063rem;
  border-bottom-left-radius: 1.063rem;
}
.rounded-l-\\[2\\.5rem\\] {
  border-top-left-radius: 2.5rem;
  border-bottom-left-radius: 2.5rem;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-xl {
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-r-3xl {
  border-top-right-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
}
.rounded-r-\\[0\\.688rem\\] {
  border-top-right-radius: 0.688rem;
  border-bottom-right-radius: 0.688rem;
}
.rounded-r-\\[0\\.875rem\\] {
  border-top-right-radius: 0.875rem;
  border-bottom-right-radius: 0.875rem;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-xl {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-none {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-bl-3xl {
  border-bottom-left-radius: 1.5rem;
}
.rounded-bl-xl {
  border-bottom-left-radius: 0.75rem;
}
.rounded-br-3xl {
  border-bottom-right-radius: 1.5rem;
}
.rounded-br-\\[0\\.875rem\\] {
  border-bottom-right-radius: 0.875rem;
}
.rounded-br-\\[2\\.5rem\\] {
  border-bottom-right-radius: 2.5rem;
}
.rounded-br-lg {
  border-bottom-right-radius: 0.5rem;
}
.rounded-tl-3xl {
  border-top-left-radius: 1.5rem;
}
.rounded-tl-\\[1\\.25rem\\] {
  border-top-left-radius: 1.25rem;
}
.rounded-tl-\\[2\\.5rem\\] {
  border-top-left-radius: 2.5rem;
}
.rounded-tl-lg {
  border-top-left-radius: 0.5rem;
}
.rounded-tr-2xl {
  border-top-right-radius: 1rem;
}
.rounded-tr-3xl {
  border-top-right-radius: 1.5rem;
}
.rounded-tr-\\[0\\.688rem\\] {
  border-top-right-radius: 0.688rem;
}
.rounded-tr-\\[0\\.875rem\\] {
  border-top-right-radius: 0.875rem;
}
.rounded-tr-lg {
  border-top-right-radius: 0.5rem;
}
.rounded-tr-xl {
  border-top-right-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-\\[3px\\] {
  border-bottom-width: 3px;
}
.border-l {
  border-left-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-none {
  border-style: none;
}
.border-pol-dark {
  --tw-border-opacity: 1;
  border-color: rgb(50 46 62 / var(--tw-border-opacity));
}
.border-pol-gray {
  --tw-border-opacity: 1;
  border-color: rgb(80 75 96 / var(--tw-border-opacity));
}
.border-pol-green-2 {
  --tw-border-opacity: 1;
  border-color: rgb(57 208 162 / var(--tw-border-opacity));
}
.border-pol-light {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 254 / var(--tw-border-opacity));
}
.border-pol-light-4 {
  --tw-border-opacity: 1;
  border-color: rgb(234 234 234 / var(--tw-border-opacity));
}
.border-pol-light-gray {
  --tw-border-opacity: 1;
  border-color: rgb(242 241 247 / var(--tw-border-opacity));
}
.border-pol-light-gray-8 {
  --tw-border-opacity: 1;
  border-color: rgb(235 233 233 / var(--tw-border-opacity));
}
.border-pol-light-gray-9 {
  --tw-border-opacity: 1;
  border-color: rgb(219 219 219 / var(--tw-border-opacity));
}
.border-pol-light-purple {
  --tw-border-opacity: 1;
  border-color: rgb(241 241 251 / var(--tw-border-opacity));
}
.border-pol-light-purple-2 {
  --tw-border-opacity: 1;
  border-color: rgb(244 238 255 / var(--tw-border-opacity));
}
.border-pol-main-dark-color {
  --tw-border-opacity: 1;
  border-color: rgb(255 182 0 / var(--tw-border-opacity));
}
.border-pol-main-purple {
  --tw-border-opacity: 1;
  border-color: rgb(100 29 255 / var(--tw-border-opacity));
}
.border-pol-pink {
  --tw-border-opacity: 1;
  border-color: rgb(253 115 223 / var(--tw-border-opacity));
}
.border-pol-purple {
  --tw-border-opacity: 1;
  border-color: rgb(151 143 171 / var(--tw-border-opacity));
}
.border-pol-purple-4 {
  --tw-border-opacity: 1;
  border-color: rgb(203 195 224 / var(--tw-border-opacity));
}
.border-pol-red {
  --tw-border-opacity: 1;
  border-color: rgb(255 117 117 / var(--tw-border-opacity));
}
.border-pol-secondary-green-3 {
  --tw-border-opacity: 1;
  border-color: rgb(168 219 60 / var(--tw-border-opacity));
}
.border-y-pol-gray {
  --tw-border-opacity: 1;
  border-top-color: rgb(80 75 96 / var(--tw-border-opacity));
  border-bottom-color: rgb(80 75 96 / var(--tw-border-opacity));
}
.border-y-pol-light-purple-2 {
  --tw-border-opacity: 1;
  border-top-color: rgb(244 238 255 / var(--tw-border-opacity));
  border-bottom-color: rgb(244 238 255 / var(--tw-border-opacity));
}
.border-y-pol-purple {
  --tw-border-opacity: 1;
  border-top-color: rgb(151 143 171 / var(--tw-border-opacity));
  border-bottom-color: rgb(151 143 171 / var(--tw-border-opacity));
}
.border-b-pol-gray {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(80 75 96 / var(--tw-border-opacity));
}
.border-b-pol-light {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(250 250 254 / var(--tw-border-opacity));
}
.border-b-pol-light-gray {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(242 241 247 / var(--tw-border-opacity));
}
.border-b-pol-light-gray-7 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(249 249 249 / var(--tw-border-opacity));
}
.border-b-pol-light-purple-2 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(244 238 255 / var(--tw-border-opacity));
}
.border-b-pol-main-dark-color {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 182 0 / var(--tw-border-opacity));
}
.border-l-pol-gray {
  --tw-border-opacity: 1;
  border-left-color: rgb(80 75 96 / var(--tw-border-opacity));
}
.border-l-pol-light-purple-2 {
  --tw-border-opacity: 1;
  border-left-color: rgb(244 238 255 / var(--tw-border-opacity));
}
.border-t-pol-light-gray {
  --tw-border-opacity: 1;
  border-top-color: rgb(242 241 247 / var(--tw-border-opacity));
}
.border-t-pol-light-purple-2 {
  --tw-border-opacity: 1;
  border-top-color: rgb(244 238 255 / var(--tw-border-opacity));
}
.bg-\\[\\#E4E2E9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(228 226 233 / var(--tw-bg-opacity));
}
.bg-pol-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(50 46 62 / var(--tw-bg-opacity));
}
.bg-pol-dark-2 {
  --tw-bg-opacity: 1;
  background-color: rgb(35 31 32 / var(--tw-bg-opacity));
}
.bg-pol-dark-pink {
  --tw-bg-opacity: 1;
  background-color: rgb(197 124 255 / var(--tw-bg-opacity));
}
.bg-pol-gray {
  --tw-bg-opacity: 1;
  background-color: rgb(80 75 96 / var(--tw-bg-opacity));
}
.bg-pol-gray-2 {
  --tw-bg-opacity: 1;
  background-color: rgb(112 107 127 / var(--tw-bg-opacity));
}
.bg-pol-gray-5 {
  --tw-bg-opacity: 1;
  background-color: rgb(201 197 213 / var(--tw-bg-opacity));
}
.bg-pol-green {
  --tw-bg-opacity: 1;
  background-color: rgb(90 234 191 / var(--tw-bg-opacity));
}
.bg-pol-green-2 {
  --tw-bg-opacity: 1;
  background-color: rgb(57 208 162 / var(--tw-bg-opacity));
}
.bg-pol-light {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 254 / var(--tw-bg-opacity));
}
.bg-pol-light-10 {
  --tw-bg-opacity: 1;
  background-color: rgb(232 230 241 / var(--tw-bg-opacity));
}
.bg-pol-light-11 {
  --tw-bg-opacity: 1;
  background-color: rgb(247 244 254 / var(--tw-bg-opacity));
}
.bg-pol-light-12 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 254 254 / var(--tw-bg-opacity));
}
.bg-pol-light-14 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 243 250 / var(--tw-bg-opacity));
}
.bg-pol-light-3 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 253 / var(--tw-bg-opacity));
}
.bg-pol-light-5 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 249 / var(--tw-bg-opacity));
}
.bg-pol-light-6 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 243 251 / var(--tw-bg-opacity));
}
.bg-pol-light-7 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 239 248 / var(--tw-bg-opacity));
}
.bg-pol-light-8 {
  --tw-bg-opacity: 1;
  background-color: rgb(242 241 243 / var(--tw-bg-opacity));
}
.bg-pol-light-9 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 251 / var(--tw-bg-opacity));
}
.bg-pol-light-gray {
  --tw-bg-opacity: 1;
  background-color: rgb(242 241 247 / var(--tw-bg-opacity));
}
.bg-pol-light-gray-10 {
  --tw-bg-opacity: 1;
  background-color: rgb(223 220 241 / var(--tw-bg-opacity));
}
.bg-pol-light-gray-3 {
  --tw-bg-opacity: 1;
  background-color: rgb(246 245 250 / var(--tw-bg-opacity));
}
.bg-pol-light-gray-4 {
  --tw-bg-opacity: 1;
  background-color: rgb(237 235 244 / var(--tw-bg-opacity));
}
.bg-pol-light-gray-5 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 239 242 / var(--tw-bg-opacity));
}
.bg-pol-light-gray-7 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity));
}
.bg-pol-light-green {
  --tw-bg-opacity: 1;
  background-color: rgb(224 251 243 / var(--tw-bg-opacity));
}
.bg-pol-light-green-2 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 247 212 / var(--tw-bg-opacity));
}
.bg-pol-light-green-3 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 221 / var(--tw-bg-opacity));
}
.bg-pol-light-orange {
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 216 / var(--tw-bg-opacity));
}
.bg-pol-light-orange-2 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 233 180 / var(--tw-bg-opacity));
}
.bg-pol-light-orange-3 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 245 220 / var(--tw-bg-opacity));
}
.bg-pol-light-orange-4 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 243 224 / var(--tw-bg-opacity));
}
.bg-pol-light-pink {
  --tw-bg-opacity: 1;
  background-color: rgb(254 221 247 / var(--tw-bg-opacity));
}
.bg-pol-light-purple {
  --tw-bg-opacity: 1;
  background-color: rgb(241 241 251 / var(--tw-bg-opacity));
}
.bg-pol-light-purple-2 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 238 255 / var(--tw-bg-opacity));
}
.bg-pol-light-purple-4 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 250 255 / var(--tw-bg-opacity));
}
.bg-pol-light-purple-5\\/10 {
  background-color: rgb(211 203 234 / 0.1);
}
.bg-pol-light-purple-6 {
  --tw-bg-opacity: 1;
  background-color: rgb(235 232 245 / var(--tw-bg-opacity));
}
.bg-pol-light-red {
  --tw-bg-opacity: 1;
  background-color: rgb(255 220 220 / var(--tw-bg-opacity));
}
.bg-pol-light-red-2 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 229 229 / var(--tw-bg-opacity));
}
.bg-pol-light-red-3 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 224 224 / var(--tw-bg-opacity));
}
.bg-pol-main-color {
  --tw-bg-opacity: 1;
  background-color: rgb(255 199 61 / var(--tw-bg-opacity));
}
.bg-pol-main-dark-color {
  --tw-bg-opacity: 1;
  background-color: rgb(255 182 0 / var(--tw-bg-opacity));
}
.bg-pol-pink {
  --tw-bg-opacity: 1;
  background-color: rgb(253 115 223 / var(--tw-bg-opacity));
}
.bg-pol-purple {
  --tw-bg-opacity: 1;
  background-color: rgb(151 143 171 / var(--tw-bg-opacity));
}
.bg-pol-purple-4 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 195 224 / var(--tw-bg-opacity));
}
.bg-pol-purple-6 {
  --tw-bg-opacity: 1;
  background-color: rgb(222 210 245 / var(--tw-bg-opacity));
}
.bg-pol-purple-7 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 232 245 / var(--tw-bg-opacity));
}
.bg-pol-purple-9 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 237 244 / var(--tw-bg-opacity));
}
.bg-pol-red {
  --tw-bg-opacity: 1;
  background-color: rgb(255 117 117 / var(--tw-bg-opacity));
}
.bg-pol-secondary-green-3 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 219 60 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-cover {
  background-size: cover;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-\\[0\\.938rem\\] {
  padding: 0.938rem;
}
.\\!px-\\[1\\.875rem\\] {
  padding-left: 1.875rem !important;
  padding-right: 1.875rem !important;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-11 {
  padding-left: 2.75rem;
  padding-right: 2.75rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-9 {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.px-\\[0\\.875rem\\] {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-\\[1\\.125rem\\] {
  padding-left: 1.125rem;
  padding-right: 1.125rem;
}
.px-\\[1\\.375rem\\] {
  padding-left: 1.375rem;
  padding-right: 1.375rem;
}
.px-\\[1\\.875rem\\] {
  padding-left: 1.875rem;
  padding-right: 1.875rem;
}
.px-\\[2\\.625rem\\] {
  padding-left: 2.625rem;
  padding-right: 2.625rem;
}
.px-\\[3\\.75rem\\] {
  padding-left: 3.75rem;
  padding-right: 3.75rem;
}
.px-px {
  padding-left: 1px;
  padding-right: 1px;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[0\\.688rem\\] {
  padding-top: 0.688rem;
  padding-bottom: 0.688rem;
}
.py-\\[0\\.813rem\\] {
  padding-top: 0.813rem;
  padding-bottom: 0.813rem;
}
.py-\\[1\\.05rem\\] {
  padding-top: 1.05rem;
  padding-bottom: 1.05rem;
}
.py-\\[1\\.125rem\\] {
  padding-top: 1.125rem;
  padding-bottom: 1.125rem;
}
.py-\\[1\\.35rem\\] {
  padding-top: 1.35rem;
  padding-bottom: 1.35rem;
}
.py-px {
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-3\\.5 {
  padding-bottom: 0.875rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-7 {
  padding-bottom: 1.75rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-9 {
  padding-bottom: 2.25rem;
}
.pb-\\[1\\.125rem\\] {
  padding-bottom: 1.125rem;
}
.pb-\\[1\\.375rem\\] {
  padding-bottom: 1.375rem;
}
.pb-\\[1\\.625rem\\] {
  padding-bottom: 1.625rem;
}
.pb-\\[1\\.875rem\\] {
  padding-bottom: 1.875rem;
}
.pb-\\[4\\.5rem\\] {
  padding-bottom: 4.5rem;
}
.pb-\\[4\\.75rem\\] {
  padding-bottom: 4.75rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-14 {
  padding-left: 3.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-32 {
  padding-left: 8rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-\\[0\\.188rem\\] {
  padding-left: 0.188rem;
}
.pl-\\[1\\.125rem\\] {
  padding-left: 1.125rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-3\\.5 {
  padding-right: 0.875rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pr-\\[1\\.875rem\\] {
  padding-right: 1.875rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-3\\.5 {
  padding-top: 0.875rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-7 {
  padding-top: 1.75rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[1\\.125rem\\] {
  padding-top: 1.125rem;
}
.pt-\\[1\\.375rem\\] {
  padding-top: 1.375rem;
}
.pt-\\[1\\.625rem\\] {
  padding-top: 1.625rem;
}
.pt-\\[3\\.125rem\\] {
  padding-top: 3.125rem;
}
.pt-\\[3\\.25rem\\] {
  padding-top: 3.25rem;
}
.pt-\\[4\\.125rem\\] {
  padding-top: 4.125rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-justify {
  text-align: justify;
}
.align-super {
  vertical-align: super;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[0\\.188rem\\] {
  font-size: 0.188rem;
}
.text-\\[0\\.438rem\\] {
  font-size: 0.438rem;
}
.text-\\[0\\.5rem\\] {
  font-size: 0.5rem;
}
.text-\\[0\\.625rem\\] {
  font-size: 0.625rem;
}
.text-\\[0\\.813rem\\] {
  font-size: 0.813rem;
}
.text-\\[0\\.938rem\\] {
  font-size: 0.938rem;
}
.text-\\[1\\.125rem\\] {
  font-size: 1.125rem;
}
.text-\\[1\\.375rem\\] {
  font-size: 1.375rem;
}
.text-\\[1\\.75rem\\] {
  font-size: 1.75rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[2rem\\] {
  font-size: 2rem;
}
.text-\\[6\\.6rem\\] {
  font-size: 6.6rem;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.leading-\\[155\\%\\] {
  line-height: 155%;
}
.leading-\\[157\\%\\] {
  line-height: 157%;
}
.leading-\\[160\\%\\] {
  line-height: 160%;
}
.leading-\\[161\\%\\] {
  line-height: 161%;
}
.leading-\\[168\\%\\] {
  line-height: 168%;
}
.leading-\\[169\\%\\] {
  line-height: 169%;
}
.leading-\\[170\\%\\] {
  line-height: 170%;
}
.leading-\\[171\\%\\] {
  line-height: 171%;
}
.tracking-\\[0\\.15em\\] {
  letter-spacing: 0.15em;
}
.tracking-\\[0\\.2em\\] {
  letter-spacing: 0.2em;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-pol-dark {
  --tw-text-opacity: 1;
  color: rgb(50 46 62 / var(--tw-text-opacity));
}
.text-pol-dark-2 {
  --tw-text-opacity: 1;
  color: rgb(35 31 32 / var(--tw-text-opacity));
}
.text-pol-dark-pink {
  --tw-text-opacity: 1;
  color: rgb(197 124 255 / var(--tw-text-opacity));
}
.text-pol-gray {
  --tw-text-opacity: 1;
  color: rgb(80 75 96 / var(--tw-text-opacity));
}
.text-pol-gray-2 {
  --tw-text-opacity: 1;
  color: rgb(112 107 127 / var(--tw-text-opacity));
}
.text-pol-gray-3 {
  --tw-text-opacity: 1;
  color: rgb(182 178 195 / var(--tw-text-opacity));
}
.text-pol-gray-4 {
  --tw-text-opacity: 1;
  color: rgb(138 134 147 / var(--tw-text-opacity));
}
.text-pol-gray-6 {
  --tw-text-opacity: 1;
  color: rgb(119 118 123 / var(--tw-text-opacity));
}
.text-pol-green {
  --tw-text-opacity: 1;
  color: rgb(90 234 191 / var(--tw-text-opacity));
}
.text-pol-green-2 {
  --tw-text-opacity: 1;
  color: rgb(57 208 162 / var(--tw-text-opacity));
}
.text-pol-light {
  --tw-text-opacity: 1;
  color: rgb(250 250 254 / var(--tw-text-opacity));
}
.text-pol-light-gray-6 {
  --tw-text-opacity: 1;
  color: rgb(221 219 230 / var(--tw-text-opacity));
}
.text-pol-light-purple-2 {
  --tw-text-opacity: 1;
  color: rgb(244 238 255 / var(--tw-text-opacity));
}
.text-pol-light-purple-4 {
  --tw-text-opacity: 1;
  color: rgb(252 250 255 / var(--tw-text-opacity));
}
.text-pol-main-color {
  --tw-text-opacity: 1;
  color: rgb(255 199 61 / var(--tw-text-opacity));
}
.text-pol-main-dark-color {
  --tw-text-opacity: 1;
  color: rgb(255 182 0 / var(--tw-text-opacity));
}
.text-pol-main-purple {
  --tw-text-opacity: 1;
  color: rgb(100 29 255 / var(--tw-text-opacity));
}
.text-pol-orange {
  --tw-text-opacity: 1;
  color: rgb(250 178 0 / var(--tw-text-opacity));
}
.text-pol-pink {
  --tw-text-opacity: 1;
  color: rgb(253 115 223 / var(--tw-text-opacity));
}
.text-pol-purple {
  --tw-text-opacity: 1;
  color: rgb(151 143 171 / var(--tw-text-opacity));
}
.text-pol-purple-2 {
  --tw-text-opacity: 1;
  color: rgb(134 122 168 / var(--tw-text-opacity));
}
.text-pol-purple-3 {
  --tw-text-opacity: 1;
  color: rgb(125 118 143 / var(--tw-text-opacity));
}
.text-pol-purple-4 {
  --tw-text-opacity: 1;
  color: rgb(203 195 224 / var(--tw-text-opacity));
}
.text-pol-purple-5 {
  --tw-text-opacity: 1;
  color: rgb(199 190 226 / var(--tw-text-opacity));
}
.text-pol-purple-8 {
  --tw-text-opacity: 1;
  color: rgb(145 140 158 / var(--tw-text-opacity));
}
.text-pol-red {
  --tw-text-opacity: 1;
  color: rgb(255 117 117 / var(--tw-text-opacity));
}
.text-pol-secondary-green {
  --tw-text-opacity: 1;
  color: rgb(140 191 32 / var(--tw-text-opacity));
}
.text-pol-secondary-green-2 {
  --tw-text-opacity: 1;
  color: rgb(147 199 35 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.line-through {
  text-decoration-line: line-through;
}
.opacity-0 {
  opacity: 0;
}
.opacity-10 {
  opacity: 0.1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-80 {
  opacity: 0.8;
}
.shadow-\\[0_0_9px_11px_rgba\\(142\\2c 130\\2c 180\\2c 0\\.06\\)\\] {
  --tw-shadow: 0 0 9px 11px rgba(142,130,180,0.06);
  --tw-shadow-colored: 0 0 9px 11px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_9px_11px_rgba\\(142\\2c 130\\2c 180\\2c 0\\.06\\)\\] {
  --tw-shadow: 0 10px 9px 11px rgba(142,130,180,0.06);
  --tw-shadow-colored: 0 10px 9px 11px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_5px_10px_-5px_rgb\\(232\\2c 232\\2c 251\\)\\] {
  --tw-shadow: 0 5px 10px -5px rgb(232,232,251);
  --tw-shadow-colored: 0 5px 10px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_5px_12px_4px_rgba\\(241\\2c 241\\2c 251\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 5px 12px 4px rgba(241,241,251,0.5);
  --tw-shadow-colored: 0 5px 12px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_0px_8px_6px_rgba\\(214\\2c 204\\2c 245\\2c 0\\.08\\)\\] {
  --tw-shadow: 0px 0px 8px 6px rgba(214,204,245,0.08);
  --tw-shadow-colored: 0px 0px 8px 6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_10px_9px_11px_rgba\\(142\\2c 130\\2c 180\\2c 0\\.06\\)\\] {
  --tw-shadow: 0px 10px 9px 11px rgba(142,130,180,0.06);
  --tw-shadow-colored: 0px 10px 9px 11px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_5px_10px_-5px_rgb\\(232\\2c 232\\2c 251\\)\\] {
  --tw-shadow: 0px 5px 10px -5px rgb(232,232,251);
  --tw-shadow-colored: 0px 5px 10px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_5px_10px_-5px_rgba\\(232\\2c 232\\2c 251\\2c 1\\)\\] {
  --tw-shadow: 0px 5px 10px -5px rgba(232,232,251,1);
  --tw-shadow-colored: 0px 5px 10px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_6px_12px_-2px_rgba\\(96\\2c 55\\2c 229\\2c 0\\.3\\)\\] {
  --tw-shadow: 0px 6px 12px -2px rgba(96,55,229,0.3);
  --tw-shadow-colored: 0px 6px 12px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_9px_12px_4px_rgba\\(143\\2c 136\\2c 166\\2c 0\\.12\\)\\] {
  --tw-shadow: 0px 9px 12px 4px rgba(143,136,166,0.12);
  --tw-shadow-colored: 0px 9px 12px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.outline-1 {
  outline-width: 1px;
}
.outline-2 {
  outline-width: 2px;
}
.outline-pol-gray {
  outline-color: #504B60;
}
.outline-pol-light-purple-2 {
  outline-color: #F4EEFF;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}

@font-face {
    font-family: "YekanBakh";
    src: local("YekanBakh"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
}

html {
    font-family: "YekanBakh";
}

.container {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.rtl {
    direction: rtl;
}

.ltr {
    direction: ltr;
}

.block-scroll {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}

/*.a {*/
/*    padding-bottom: env(safe-area-inset-bottom)*/
/*}*/

.scroll-none::-webkit-scrollbar {
  display: none;
}

.pol-scroll::-webkit-scrollbar {
  width: 0.438rem;
}

.pol-scroll::-webkit-scrollbar-track {
    border-radius: 15px;
    background: #f1f1f1;
}

.pol-scroll::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 15px;
}

.pol-scroll::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.pol-purple-scroll::-webkit-scrollbar {
  width: 0.438rem;
}

.pol-purple-scroll::-webkit-scrollbar-track {
    border-radius: 30px;
    background: rgb(203, 195, 224);
    background: linear-gradient(0deg, rgba(203, 195, 224, 0.4) 0%, rgba(203, 195, 224, 0) 100%);
}

.pol-purple-scroll::-webkit-scrollbar-thumb {
    background: #CBC3E0;
    border-radius: 30px;
}

.pol-purple-scroll::-webkit-scrollbar-thumb:hover {
    background: #555;
}

/* Shadows */
.notify-shadow-green {
  --tw-bg-opacity: 1;
  background-color: rgb(90 234 191 / var(--tw-bg-opacity));
  --tw-shadow: 0 3px 12px 4px rgba(90,234,191,0.47);
  --tw-shadow-colored: 0 3px 12px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.notify-shadow-orange {
  --tw-bg-opacity: 1;
  background-color: rgb(255 182 0 / var(--tw-bg-opacity));
  --tw-shadow: 0 3px 12px 4px rgba(255,182,0,0.47);
  --tw-shadow-colored: 0 3px 12px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.notify-shadow-red {
  --tw-bg-opacity: 1;
  background-color: rgb(255 117 117 / var(--tw-bg-opacity));
  --tw-shadow: 0 3px 12px 4px rgba(255,117,117,0.47);
  --tw-shadow-colored: 0 3px 12px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

/* Buttons */
button[disabled="disabled"], button[diabled] {
  cursor: not-allowed;
}

.btn-main-outline {
    /*@apply inline-block rounded-xl text-pol-blue border border-pol-blue*/
}

.btn-outline-dark-orange {
  display: inline-block;
  border-radius: 0.688rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(255 182 0 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 182 0 / var(--tw-text-opacity));
}

.btn-orange {
  display: inline-block;
  border-radius: 0.688rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 182 0 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(50 46 62 / var(--tw-text-opacity));
}

.btn-main-purple {
  display: inline-block;
  border-radius: 0.688rem;
  --tw-bg-opacity: 1;
  background-color: rgb(100 29 255 / var(--tw-bg-opacity));
}

.btn-main-dark {
  display: inline-block;
  border-radius: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(50 46 62 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(244 238 255 / var(--tw-text-opacity));
}

.btn-purple {
  display: inline-block;
  border-radius: 0.688rem;
  --tw-bg-opacity: 1;
  background-color: rgb(151 143 171 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.btn-outline-main-dark {
  display: inline-block;
  border-radius: 0.688rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(50 46 62 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(50 46 62 / var(--tw-text-opacity));
}

.btn-dark {
  display: inline-block;
  border-radius: 0.688rem;
  --tw-bg-opacity: 1;
  background-color: rgb(35 31 32 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.btn-outline-dark {
  display: inline-block;
  border-radius: 0.688rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(35 31 32 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(35 31 32 / var(--tw-text-opacity));
}

.btn-outline-gray {
  display: inline-block;
  border-radius: 0.688rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(80 75 96 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(80 75 96 / var(--tw-text-opacity));
}

.btn-gray {
  display: inline-block;
  border-radius: 0.688rem;
  --tw-bg-opacity: 1;
  background-color: rgb(80 75 96 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.btn-light-gray {
  display: inline-block;
  border-radius: 0.688rem;
  --tw-bg-opacity: 1;
  background-color: rgb(242 241 247 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(151 143 171 / var(--tw-text-opacity));
}

.btn-outline-red {
  display: inline-block;
  border-radius: 0.688rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(255 117 117 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 117 117 / var(--tw-text-opacity));
}

.btn-red {
  display: inline-block;
  border-radius: 0.688rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 117 117 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}


/* Dropdown */

.pol-dropdown-tree .infinite-scroll-component {
  padding-bottom: 2rem;
}

.pol-dropdown-tree .dropdown {
  width: 100%;
}

.pol-dropdown-tree .dropdown-trigger {
  width: 100% !important;
  border-style: none !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.pol-dropdown-tree .dropdown-trigger .tag-list .tag-item span.tag {
  display: none;
}

.pol-dropdown-tree .dropdown-trigger .tag-list,
.pol-dropdown-tree .dropdown-trigger .tag-list .tag-item,
.pol-dropdown-tree .dropdown-trigger .tag-list .tag-item input {
  margin: 0px;
  display: block;
  width: 100%;
}

.pol-dropdown-tree .dropdown-trigger .tag-list .tag-item input {
  border-radius: 0.625rem;
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity));
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(151 143 171 / var(--tw-text-opacity));
}

.pol-dropdown-tree .dropdown-trigger:after {
  display: none;
}

.pol-dropdown-tree .dropdown-content {
  width: 100% !important;
  border-style: none !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 0px !important;
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.pol-dropdown-tree .dropdown-content .node {
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(50 46 62 / var(--tw-text-opacity));
}

.pol-dropdown-tree .dropdown-content .node.focused {
  background-color: transparent !important;
}

.pol-dropdown-tree .dropdown-content .node.leaf {
  padding-right: 1rem;
}

.pol-dropdown-tree .dropdown-content .node.leaf[aria-level="1"] {
  padding-right: 0px;
}

.pol-dropdown-tree .dropdown-content .node.leaf[aria-level="1"] > i {
  display: none;
}

.pol-dropdown-tree .dropdown-content .node.leaf:last-child {
  margin-bottom: 0.75rem;
}

.pol-dropdown-tree .dropdown-content .node.tree label input.checkbox-item,
.pol-dropdown-tree .dropdown-content .node.leaf label input.checkbox-item {
  position: relative;
  margin-left: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(100 29 255 / var(--tw-bg-opacity));
}

.pol-dropdown-tree .dropdown-content .node.tree label input.checkbox-item::after,
.pol-dropdown-tree .dropdown-content .node.leaf label input.checkbox-item::after {
  pointer-events: none;
  position: absolute;
  left: -0.25rem;
  top: -0.25rem;
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 0.313rem;
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(239 239 242 / var(--tw-bg-opacity));
}

.pol-dropdown-tree .dropdown-content .node.tree label input:checked.checkbox-item::before,
.pol-dropdown-tree .dropdown-content .node.leaf label input:checked.checkbox-item::before {
  position: absolute;
  left: 0.125rem;
  bottom: -0.375rem;
  z-index: 10;
  font-weight: 700;
  --tw-content: '\\2713';
  content: var(--tw-content);
}

.pol-dropdown-tree .dropdown-content .node.tree i {
  position: absolute;
  left: 0px;
}

.pol-dropdown-tree .dropdown-content .node.tree i.toggle {
  opacity: 0;
}

.pol-dropdown-tree .dropdown-content .node.tree[aria-expanded="true"] i:not(.toggle) {
  --tw-rotate: 0deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.pol-dropdown-tree .dropdown-content .node.tree i:not(.toggle) {
  pointer-events: none;
  transition-duration: 200ms;
}

.pol-dropdown-tree .icon-simple-arrow-left {
  height: 0.25rem;
  width: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 117 117 / var(--tw-bg-opacity));
}

.pol-tag-input .rti--container {
  border-radius: 0.875rem;
  transition-duration: 300ms;
}

.pol-tag-input .rti--container:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(255 182 0 / var(--tw-border-opacity));
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.pol-tag-input .rti--input {
  flex-grow: 1;
  padding-left: 0.875rem;
  padding-right: 0.875rem;
  padding-top: 0.188rem !important;
  padding-bottom: 0.188rem !important;
  --tw-text-opacity: 1;
  color: rgb(80 75 96 / var(--tw-text-opacity));
}

.pol-tag-input .rti--input::placeholder {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.pol-tag-input .rti--tag {
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(246 245 250 / var(--tw-bg-opacity));
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.313rem;
  padding-bottom: 0.313rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(80 75 96 / var(--tw-text-opacity));
}

.pol-tag-input .rti--tag button {
  margin-right: 1.625rem;
  margin-top: 0.25rem;
  padding: 0px;
}


/* Globals */
.sidebar-links .active div {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 199 61 / var(--tw-border-opacity)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 199 61 / var(--tw-bg-opacity)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(35 31 32 / var(--tw-text-opacity)) !important;
  --tw-drop-shadow: drop-shadow(0 6px 12px rgba(255,182,0,0.3)) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}

.sidebar-links .active span {
  --tw-text-opacity: 1 !important;
  color: rgb(35 31 32 / var(--tw-text-opacity)) !important;
}

.sidebar-links .sub-active div {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(50 46 62 / var(--tw-bg-opacity)) !important;
}

.sidebar-links .sub-active span {
  --tw-text-opacity: 1 !important;
  color: rgb(50 46 62 / var(--tw-text-opacity)) !important;
}


/* Modals */
.pol-simple-modal .react-responsive-modal-container {
  padding-top: 1.25rem;
}

.pol-simple-modal .react-responsive-modal-overlay {
    background: rgb(50, 46, 62);
    background: linear-gradient(225deg, rgba(50, 46, 62, 0.8) 0%, rgba(50, 46, 62, 1) 100%);
}

.pol-simple-modal .react-responsive-modal-modal {
  margin: 0px;
  min-height: 65vh;
  width: 100%;
  overflow: visible;
  background-color: transparent;
  padding: 0px;
  text-align: right;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@media (min-width: 1024px) {

  .pol-simple-modal .react-responsive-modal-modal {
    margin: 1.2rem;
    min-height: unset;
    width: auto;
  }
}

.pol-simple-modal.center .react-responsive-modal-modal {
  margin: auto !important;
}

.pol-simple-modal .react-responsive-modal-closeButton {
  left: 1rem;
  top: -2.5rem;
  right: unset;
}

.pol-simple-modal .react-responsive-modal-container {
  display: flex;
  align-items: flex-end;
}

@media (min-width: 1024px) {

  .pol-simple-modal .react-responsive-modal-container {
    display: block;
  }
}

.pol-simple-modal .react-responsive-modal-closeButton {
  display: none;
}

@media (min-width: 1024px) {

  .pol-simple-modal .react-responsive-modal-closeButton {
    display: flex;
  }
}

/*Spring modal*/
.pol-bottom-sheet div[data-rsbs-backdrop] {
    background: linear-gradient(222deg, rgba(50,46,62,0.8) 0%, rgba(50,46,62,1) 100%);
    z-index: 100}

.pol-bottom-sheet div[data-rsbs-overlay] {
  z-index: 110;
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}

/* Audio */
.pol-audio-container .rhap_volume-bar-area,
.pol-audio-container .rhap_time,
.pol-audio-container .rhap_progress-indicator {
  display: none;
}

.pol-audio-container .rhap_container {
  border-radius: 0.688rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(242 241 247 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 254 / var(--tw-bg-opacity));
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.pol-audio-container .rhap_controls-section {
  flex: none;
}

.pol-audio-container .rhap_play-pause-button {
  width: 1.25rem;
}

.pol-audio-container .rhap_volume-container {
  flex: none;
}

.pol-audio-container .rhap_progress-filled {
  border-radius: 3px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 182 0 / var(--tw-bg-opacity));
}

.pol-audio-container .rhap_download-progress {
  --tw-bg-opacity: 1;
  background-color: rgb(151 143 171 / var(--tw-bg-opacity));
}

.pol-audio-container .rhap_progress-bar-show-download {
  height: 0.25rem;
  border-radius: 3px;
  background-color: rgb(151 143 171 / 0.6);
}

/* Guide modal*/
.guide-content a {
  display: inline-block;
  font-weight: 600;
}

/* Toast */
.Toastify__toast .Toastify__toast-body {
    font-family: "YekanBakh";
    text-align: right;
    font-size: 0.875rem;
    line-height: 1.25rem;
    direction: rtl}

.Toastify__toast-container--top-right {
  right: 0px !important;
}

/*Pol single dropdown tree*/
.pol-single-dropdown-tree button.collapsed-node {
  margin-bottom: 0px !important;
}

.pol-single-dropdown-tree button.collapsed-node i {
  --tw-rotate: 0deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.pol-single-dropdown-tree ul.sub-list.collapsed {
  margin: 0px;
  height: 0px;
  overflow: hidden;
  padding: 0px;
}

/* Transaction Page */
.transaction-data .active-filter {
  border-radius: 0.438rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 233 180 / var(--tw-bg-opacity));
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  --tw-text-opacity: 1;
  color: rgb(35 31 32 / var(--tw-text-opacity));
}

/*Date picker*/
.rmdp-week-day, .rmdp-action-button {
  --tw-text-opacity: 1 !important;
  color: rgb(255 199 61 / var(--tw-text-opacity)) !important;
}

.rmdp-day:not(.rmdp-disabled,.rmdp-day-hidden) span:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 199 61 / var(--tw-bg-opacity)) !important;
}

.rmdp-day.rmdp-selected span:not(.highlight) {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 182 0 / var(--tw-bg-opacity)) !important;
}

.rmdp-arrow {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 199 61 / var(--tw-border-opacity)) !important;
}

.ticket-message-container ol, .ticket-message-container ul {
    padding-right: 40px;
}

.ticket-message-container ol {
    list-style-type: decimal;
}

.ticket-message-container ul {
    list-style-type: disc;
}

.ticket-message-container span {
  display: inline-block;
}

@media screen and (max-width: 1279px) {
    .container {
    max-width: 850px;
    padding-left: 0.938rem;
    padding-right: 0.938rem;
  }

    .m-padding-x {
    padding-left: 0.938rem;
    padding-right: 0.938rem;
  }
}

@media screen and (min-width: 1280px) {
    .container {
    max-width: 1440px;
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
}

.placeholder\\:text-sm::placeholder {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.placeholder\\:font-semibold::placeholder {
  font-weight: 600;
}

.placeholder\\:text-pol-purple::placeholder {
  --tw-text-opacity: 1;
  color: rgb(151 143 171 / var(--tw-text-opacity));
}

.placeholder\\:text-pol-purple-4::placeholder {
  --tw-text-opacity: 1;
  color: rgb(203 195 224 / var(--tw-text-opacity));
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:bottom-\\[0\\.188rem\\]::before {
  content: var(--tw-content);
  bottom: 0.188rem;
}

.before\\:left-\\[0\\.3rem\\]::before {
  content: var(--tw-content);
  left: 0.3rem;
}

.before\\:h-\\[1\\.063rem\\]::before {
  content: var(--tw-content);
  height: 1.063rem;
}

.before\\:w-\\[1\\.063rem\\]::before {
  content: var(--tw-content);
  width: 1.063rem;
}

.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}

.before\\:bg-pol-main-dark-color::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 182 0 / var(--tw-bg-opacity));
}

.before\\:bg-pol-main-purple::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(100 29 255 / var(--tw-bg-opacity));
}

.before\\:bg-pol-purple::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(151 143 171 / var(--tw-bg-opacity));
}

.before\\:duration-300::before {
  content: var(--tw-content);
  transition-duration: 300ms;
}

.first\\:mt-3:first-child {
  margin-top: 0.75rem;
}

.first\\:rounded-tl-3xl:first-child {
  border-top-left-radius: 1.5rem;
}

.first\\:rounded-tr-\\[0\\.875rem\\]:first-child {
  border-top-right-radius: 0.875rem;
}

.last\\:mb-2:last-child {
  margin-bottom: 0.5rem;
}

.last\\:mb-2\\.5:last-child {
  margin-bottom: 0.625rem;
}

.last\\:rounded-b-\\[0\\.875rem\\]:last-child {
  border-bottom-right-radius: 0.875rem;
  border-bottom-left-radius: 0.875rem;
}

.hover\\:border-pol-green:hover {
  --tw-border-opacity: 1;
  border-color: rgb(90 234 191 / var(--tw-border-opacity));
}

.hover\\:border-pol-main-dark-color:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 182 0 / var(--tw-border-opacity));
}

.hover\\:border-pol-main-purple:hover {
  --tw-border-opacity: 1;
  border-color: rgb(100 29 255 / var(--tw-border-opacity));
}

.hover\\:border-pol-pink:hover {
  --tw-border-opacity: 1;
  border-color: rgb(253 115 223 / var(--tw-border-opacity));
}

.hover\\:border-pol-purple:hover {
  --tw-border-opacity: 1;
  border-color: rgb(151 143 171 / var(--tw-border-opacity));
}

.hover\\:border-pol-red:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 117 117 / var(--tw-border-opacity));
}

.hover\\:bg-pol-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(50 46 62 / var(--tw-bg-opacity));
}

.hover\\:bg-pol-dark-2:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(35 31 32 / var(--tw-bg-opacity));
}

.hover\\:bg-pol-light-13:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 228 231 / var(--tw-bg-opacity));
}

.hover\\:bg-pol-light-2:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 241 250 / var(--tw-bg-opacity));
}

.hover\\:bg-pol-light-orange-2:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 233 180 / var(--tw-bg-opacity));
}

.hover\\:bg-pol-light-purple-4:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(252 250 255 / var(--tw-bg-opacity));
}

.hover\\:text-pol-dark-2:hover {
  --tw-text-opacity: 1;
  color: rgb(35 31 32 / var(--tw-text-opacity));
}

.hover\\:text-pol-main-color:hover {
  --tw-text-opacity: 1;
  color: rgb(255 199 61 / var(--tw-text-opacity));
}

.hover\\:text-pol-main-dark-color:hover {
  --tw-text-opacity: 1;
  color: rgb(255 182 0 / var(--tw-text-opacity));
}

.hover\\:text-pol-main-purple:hover {
  --tw-text-opacity: 1;
  color: rgb(100 29 255 / var(--tw-text-opacity));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.hover\\:outline-pol-dark-2:hover {
  outline-color: #231F20;
}

.focus\\:border-pol-main-dark-color:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 182 0 / var(--tw-border-opacity));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.group:first-child .group-first\\:rounded-tl-3xl {
  border-top-left-radius: 1.5rem;
}

.group:first-child .group-first\\:rounded-tr-\\[0\\.875rem\\] {
  border-top-right-radius: 0.875rem;
}

.group:last-child .group-last\\:rounded-b-\\[0\\.875rem\\] {
  border-bottom-right-radius: 0.875rem;
  border-bottom-left-radius: 0.875rem;
}

.group:hover .group-hover\\:border-pol-dark {
  --tw-border-opacity: 1;
  border-color: rgb(50 46 62 / var(--tw-border-opacity));
}

.group:hover .group-hover\\:border-pol-light-purple-3 {
  --tw-border-opacity: 1;
  border-color: rgb(224 214 242 / var(--tw-border-opacity));
}

.group:hover .group-hover\\:bg-pol-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(50 46 62 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:fill-pol-main-purple {
  fill: #641DFF;
}

.group:hover .group-hover\\:text-pol-dark {
  --tw-text-opacity: 1;
  color: rgb(50 46 62 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:text-pol-dark-2 {
  --tw-text-opacity: 1;
  color: rgb(35 31 32 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:text-pol-main-color {
  --tw-text-opacity: 1;
  color: rgb(255 199 61 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:text-pol-main-purple {
  --tw-text-opacity: 1;
  color: rgb(100 29 255 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:hover\\:text-pol-main-purple:hover {
  --tw-text-opacity: 1;
  color: rgb(100 29 255 / var(--tw-text-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:translate-x-\\[1\\.3rem\\]::before {
  content: var(--tw-content);
  --tw-translate-x: 1.3rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@media (min-width: 640px) {

  .sm\\:flex {
    display: flex;
  }

  .sm\\:h-\\[25rem\\] {
    height: 25rem;
  }

  .sm\\:w-\\[14rem\\] {
    width: 14rem;
  }

  .sm\\:w-\\[15\\.938rem\\] {
    width: 15.938rem;
  }

  .sm\\:w-\\[20\\.438rem\\] {
    width: 20.438rem;
  }

  .sm\\:w-\\[25rem\\] {
    width: 25rem;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:flex-grow {
    flex-grow: 1;
  }

  .sm\\:flex-grow-0 {
    flex-grow: 0;
  }

  .sm\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-x-2 {
    column-gap: 0.5rem;
  }

  .sm\\:gap-x-2\\.5 {
    column-gap: 0.625rem;
  }

  .sm\\:gap-x-3 {
    column-gap: 0.75rem;
  }

  .sm\\:gap-x-3\\.5 {
    column-gap: 0.875rem;
  }

  .sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:px-14 {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-3\\.5 {
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media (min-width: 768px) {

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:w-\\[37\\.5rem\\] {
    width: 37.5rem;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:flex-grow-0 {
    flex-grow: 0;
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .md\\:items-stretch {
    align-items: stretch;
  }

  .md\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .md\\:py-\\[1\\.35rem\\] {
    padding-top: 1.35rem;
    padding-bottom: 1.35rem;
  }
}

@media (min-width: 1024px) {

  .lg\\:w-\\[18\\.375rem\\] {
    width: 18.375rem;
  }

  .lg\\:w-\\[29\\.5rem\\] {
    width: 29.5rem;
  }

  .lg\\:w-\\[37\\.5rem\\] {
    width: 37.5rem;
  }

  .lg\\:w-\\[37\\.688rem\\] {
    width: 37.688rem;
  }

  .lg\\:w-\\[38\\.875rem\\] {
    width: 38.875rem;
  }

  .lg\\:min-w-\\[50\\.563rem\\] {
    min-width: 50.563rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:static {
    position: static;
  }

  .xl\\:relative {
    position: relative;
  }

  .xl\\:left-\\[unset\\] {
    left: unset;
  }

  .xl\\:right-0 {
    right: 0px;
  }

  .xl\\:top-6 {
    top: 1.5rem;
  }

  .xl\\:top-\\[unset\\] {
    top: unset;
  }

  .xl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .xl\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .xl\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .xl\\:mx-2\\.5 {
    margin-left: 0.625rem;
    margin-right: 0.625rem;
  }

  .xl\\:my-0 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .xl\\:mb-0 {
    margin-bottom: 0px;
  }

  .xl\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .xl\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .xl\\:mb-3\\.5 {
    margin-bottom: 0.875rem;
  }

  .xl\\:ml-1 {
    margin-left: 0.25rem;
  }

  .xl\\:ml-1\\.5 {
    margin-left: 0.375rem;
  }

  .xl\\:ml-2 {
    margin-left: 0.5rem;
  }

  .xl\\:ml-2\\.5 {
    margin-left: 0.625rem;
  }

  .xl\\:ml-4 {
    margin-left: 1rem;
  }

  .xl\\:ml-5 {
    margin-left: 1.25rem;
  }

  .xl\\:ml-6 {
    margin-left: 1.5rem;
  }

  .xl\\:ml-7 {
    margin-left: 1.75rem;
  }

  .xl\\:ml-\\[1\\.125rem\\] {
    margin-left: 1.125rem;
  }

  .xl\\:mr-0 {
    margin-right: 0px;
  }

  .xl\\:mr-2 {
    margin-right: 0.5rem;
  }

  .xl\\:mr-4 {
    margin-right: 1rem;
  }

  .xl\\:mr-5 {
    margin-right: 1.25rem;
  }

  .xl\\:mr-\\[11\\.688rem\\] {
    margin-right: 11.688rem;
  }

  .xl\\:mt-0 {
    margin-top: 0px;
  }

  .xl\\:mt-1 {
    margin-top: 0.25rem;
  }

  .xl\\:mt-1\\.5 {
    margin-top: 0.375rem;
  }

  .xl\\:mt-16 {
    margin-top: 4rem;
  }

  .xl\\:mt-2 {
    margin-top: 0.5rem;
  }

  .xl\\:mt-2\\.5 {
    margin-top: 0.625rem;
  }

  .xl\\:mt-4 {
    margin-top: 1rem;
  }

  .xl\\:mt-5 {
    margin-top: 1.25rem;
  }

  .xl\\:mt-6 {
    margin-top: 1.5rem;
  }

  .xl\\:mt-7 {
    margin-top: 1.75rem;
  }

  .xl\\:mt-8 {
    margin-top: 2rem;
  }

  .xl\\:mt-auto {
    margin-top: auto;
  }

  .xl\\:block {
    display: block;
  }

  .xl\\:inline-block {
    display: inline-block;
  }

  .xl\\:inline {
    display: inline;
  }

  .xl\\:flex {
    display: flex;
  }

  .xl\\:inline-flex {
    display: inline-flex;
  }

  .xl\\:grid {
    display: grid;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:h-\\[1\\.875rem\\] {
    height: 1.875rem;
  }

  .xl\\:h-\\[28rem\\] {
    height: 28rem;
  }

  .xl\\:h-\\[3\\.25rem\\] {
    height: 3.25rem;
  }

  .xl\\:h-\\[3\\.875rem\\] {
    height: 3.875rem;
  }

  .xl\\:h-\\[31\\.5rem\\] {
    height: 31.5rem;
  }

  .xl\\:h-\\[calc\\(100vh-16\\.8rem\\)\\] {
    height: calc(100vh - 16.8rem);
  }

  .xl\\:h-auto {
    height: auto;
  }

  .xl\\:max-h-\\[17\\.5rem\\] {
    max-height: 17.5rem;
  }

  .xl\\:max-h-\\[28rem\\] {
    max-height: 28rem;
  }

  .xl\\:max-h-\\[unset\\] {
    max-height: unset;
  }

  .xl\\:min-h-\\[25rem\\] {
    min-height: 25rem;
  }

  .xl\\:min-h-\\[unset\\] {
    min-height: unset;
  }

  .xl\\:w-1 {
    width: 0.25rem;
  }

  .xl\\:w-1\\.5 {
    width: 0.375rem;
  }

  .xl\\:w-36 {
    width: 9rem;
  }

  .xl\\:w-52 {
    width: 13rem;
  }

  .xl\\:w-56 {
    width: 14rem;
  }

  .xl\\:w-80 {
    width: 20rem;
  }

  .xl\\:w-\\[1\\.875rem\\] {
    width: 1.875rem;
  }

  .xl\\:w-\\[11\\.875rem\\] {
    width: 11.875rem;
  }

  .xl\\:w-\\[16\\.875rem\\] {
    width: 16.875rem;
  }

  .xl\\:w-\\[18\\.375rem\\] {
    width: 18.375rem;
  }

  .xl\\:w-\\[18\\.5rem\\] {
    width: 18.5rem;
  }

  .xl\\:w-\\[18\\.75rem\\] {
    width: 18.75rem;
  }

  .xl\\:w-\\[19\\.5rem\\] {
    width: 19.5rem;
  }

  .xl\\:w-\\[22\\.5rem\\] {
    width: 22.5rem;
  }

  .xl\\:w-\\[24\\.1\\%\\] {
    width: 24.1%;
  }

  .xl\\:w-\\[24\\.23\\%\\] {
    width: 24.23%;
  }

  .xl\\:w-\\[24\\.375rem\\] {
    width: 24.375rem;
  }

  .xl\\:w-\\[27\\.5rem\\] {
    width: 27.5rem;
  }

  .xl\\:w-\\[27\\.625rem\\] {
    width: 27.625rem;
  }

  .xl\\:w-\\[27\\.875rem\\] {
    width: 27.875rem;
  }

  .xl\\:w-\\[27rem\\] {
    width: 27rem;
  }

  .xl\\:w-\\[3\\.063rem\\] {
    width: 3.063rem;
  }

  .xl\\:w-\\[30\\.25rem\\] {
    width: 30.25rem;
  }

  .xl\\:w-\\[34\\.1\\%\\] {
    width: 34.1%;
  }

  .xl\\:w-\\[35\\.6\\%\\] {
    width: 35.6%;
  }

  .xl\\:w-\\[36\\.125rem\\] {
    width: 36.125rem;
  }

  .xl\\:w-\\[36rem\\] {
    width: 36rem;
  }

  .xl\\:w-\\[37\\.5rem\\] {
    width: 37.5rem;
  }

  .xl\\:w-\\[37\\.75rem\\] {
    width: 37.75rem;
  }

  .xl\\:w-\\[37rem\\] {
    width: 37rem;
  }

  .xl\\:w-\\[41\\%\\] {
    width: 41%;
  }

  .xl\\:w-\\[41\\.8\\%\\] {
    width: 41.8%;
  }

  .xl\\:w-\\[46\\%\\] {
    width: 46%;
  }

  .xl\\:w-\\[50\\.563rem\\] {
    width: 50.563rem;
  }

  .xl\\:w-\\[54\\%\\] {
    width: 54%;
  }

  .xl\\:w-\\[59\\%\\] {
    width: 59%;
  }

  .xl\\:w-\\[64\\.4\\%\\] {
    width: 64.4%;
  }

  .xl\\:w-\\[75\\.77\\%\\] {
    width: 75.77%;
  }

  .xl\\:w-\\[8\\.375rem\\] {
    width: 8.375rem;
  }

  .xl\\:w-\\[8\\.875rem\\] {
    width: 8.875rem;
  }

  .xl\\:w-\\[9\\.375rem\\] {
    width: 9.375rem;
  }

  .xl\\:w-auto {
    width: auto;
  }

  .xl\\:min-w-\\[11\\.688rem\\] {
    min-width: 11.688rem;
  }

  .xl\\:min-w-\\[12\\.5rem\\] {
    min-width: 12.5rem;
  }

  .xl\\:min-w-\\[24\\.5rem\\] {
    min-width: 24.5rem;
  }

  .xl\\:min-w-\\[5rem\\] {
    min-width: 5rem;
  }

  .xl\\:min-w-\\[7\\.3rem\\] {
    min-width: 7.3rem;
  }

  .xl\\:min-w-\\[8\\.125rem\\] {
    min-width: 8.125rem;
  }

  .xl\\:min-w-\\[8\\.375rem\\] {
    min-width: 8.375rem;
  }

  .xl\\:min-w-\\[9\\.125rem\\] {
    min-width: 9.125rem;
  }

  .xl\\:min-w-\\[unset\\] {
    min-width: unset;
  }

  .xl\\:max-w-\\[22\\.5rem\\] {
    max-width: 22.5rem;
  }

  .xl\\:max-w-\\[24\\.5rem\\] {
    max-width: 24.5rem;
  }

  .xl\\:max-w-\\[80\\%\\] {
    max-width: 80%;
  }

  .xl\\:max-w-full {
    max-width: 100%;
  }

  .xl\\:flex-grow {
    flex-grow: 1;
  }

  .xl\\:flex-grow-0 {
    flex-grow: 0;
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .xl\\:items-start {
    align-items: flex-start;
  }

  .xl\\:items-center {
    align-items: center;
  }

  .xl\\:justify-start {
    justify-content: flex-start;
  }

  .xl\\:justify-end {
    justify-content: flex-end;
  }

  .xl\\:justify-between {
    justify-content: space-between;
  }

  .xl\\:gap-x-14 {
    column-gap: 3.5rem;
  }

  .xl\\:gap-y-0 {
    row-gap: 0px;
  }

  .xl\\:gap-y-3 {
    row-gap: 0.75rem;
  }

  .xl\\:gap-y-3\\.5 {
    row-gap: 0.875rem;
  }

  .xl\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .xl\\:space-y-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
  }

  .xl\\:space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
  }

  .xl\\:space-y-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  }

  .xl\\:space-y-3\\.5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
  }

  .xl\\:space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .xl\\:overflow-y-auto {
    overflow-y: auto;
  }

  .xl\\:overflow-x-visible {
    overflow-x: visible;
  }

  .xl\\:overflow-y-visible {
    overflow-y: visible;
  }

  .xl\\:whitespace-normal {
    white-space: normal;
  }

  .xl\\:rounded-b-none {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  .xl\\:rounded-l-\\[2\\.5rem\\] {
    border-top-left-radius: 2.5rem;
    border-bottom-left-radius: 2.5rem;
  }

  .xl\\:rounded-l-xl {
    border-top-left-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }

  .xl\\:rounded-br-\\[2\\.5rem\\] {
    border-bottom-right-radius: 2.5rem;
  }

  .xl\\:rounded-tr-2xl {
    border-top-right-radius: 1rem;
  }

  .xl\\:border-y {
    border-top-width: 1px;
    border-bottom-width: 1px;
  }

  .xl\\:border-b {
    border-bottom-width: 1px;
  }

  .xl\\:border-l {
    border-left-width: 1px;
  }

  .xl\\:border-t-0 {
    border-top-width: 0px;
  }

  .xl\\:border-y-pol-light-purple-2 {
    --tw-border-opacity: 1;
    border-top-color: rgb(244 238 255 / var(--tw-border-opacity));
    border-bottom-color: rgb(244 238 255 / var(--tw-border-opacity));
  }

  .xl\\:border-b-pol-light-purple-2 {
    --tw-border-opacity: 1;
    border-bottom-color: rgb(244 238 255 / var(--tw-border-opacity));
  }

  .xl\\:border-l-pol-light-purple-2 {
    --tw-border-opacity: 1;
    border-left-color: rgb(244 238 255 / var(--tw-border-opacity));
  }

  .xl\\:bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }

  .xl\\:p-\\[1\\.375rem\\] {
    padding: 1.375rem;
  }

  .xl\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .xl\\:px-1\\.5 {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
  }

  .xl\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .xl\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .xl\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .xl\\:px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .xl\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .xl\\:px-3\\.5 {
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }

  .xl\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .xl\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .xl\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .xl\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .xl\\:px-9 {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .xl\\:px-\\[1\\.125rem\\] {
    padding-left: 1.125rem;
    padding-right: 1.125rem;
  }

  .xl\\:px-\\[4\\.25rem\\] {
    padding-left: 4.25rem;
    padding-right: 4.25rem;
  }

  .xl\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .xl\\:py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .xl\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .xl\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .xl\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .xl\\:py-3\\.5 {
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }

  .xl\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .xl\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .xl\\:py-\\[0\\.813rem\\] {
    padding-top: 0.813rem;
    padding-bottom: 0.813rem;
  }

  .xl\\:py-\\[1\\.125rem\\] {
    padding-top: 1.125rem;
    padding-bottom: 1.125rem;
  }

  .xl\\:py-\\[1\\.375rem\\] {
    padding-top: 1.375rem;
    padding-bottom: 1.375rem;
  }

  .xl\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .xl\\:pb-2 {
    padding-bottom: 0.5rem;
  }

  .xl\\:pb-2\\.5 {
    padding-bottom: 0.625rem;
  }

  .xl\\:pb-4 {
    padding-bottom: 1rem;
  }

  .xl\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .xl\\:pb-8 {
    padding-bottom: 2rem;
  }

  .xl\\:pb-9 {
    padding-bottom: 2.25rem;
  }

  .xl\\:pb-\\[1\\.375rem\\] {
    padding-bottom: 1.375rem;
  }

  .xl\\:pl-14 {
    padding-left: 3.5rem;
  }

  .xl\\:pl-2 {
    padding-left: 0.5rem;
  }

  .xl\\:pl-2\\.5 {
    padding-left: 0.625rem;
  }

  .xl\\:pl-24 {
    padding-left: 6rem;
  }

  .xl\\:pl-3 {
    padding-left: 0.75rem;
  }

  .xl\\:pl-4 {
    padding-left: 1rem;
  }

  .xl\\:pl-5 {
    padding-left: 1.25rem;
  }

  .xl\\:pl-6 {
    padding-left: 1.5rem;
  }

  .xl\\:pl-7 {
    padding-left: 1.75rem;
  }

  .xl\\:pl-\\[1\\.125rem\\] {
    padding-left: 1.125rem;
  }

  .xl\\:pl-\\[5\\.625rem\\] {
    padding-left: 5.625rem;
  }

  .xl\\:pl-px {
    padding-left: 1px;
  }

  .xl\\:pr-2 {
    padding-right: 0.5rem;
  }

  .xl\\:pr-2\\.5 {
    padding-right: 0.625rem;
  }

  .xl\\:pr-4 {
    padding-right: 1rem;
  }

  .xl\\:pr-6 {
    padding-right: 1.5rem;
  }

  .xl\\:pr-\\[0\\.938rem\\] {
    padding-right: 0.938rem;
  }

  .xl\\:pt-0 {
    padding-top: 0px;
  }

  .xl\\:pt-12 {
    padding-top: 3rem;
  }

  .xl\\:pt-5 {
    padding-top: 1.25rem;
  }

  .xl\\:pt-8 {
    padding-top: 2rem;
  }

  .xl\\:pt-9 {
    padding-top: 2.25rem;
  }

  .xl\\:text-left {
    text-align: left;
  }

  .xl\\:text-center {
    text-align: center;
  }

  .xl\\:text-right {
    text-align: right;
  }

  .xl\\:text-start {
    text-align: start;
  }

  .xl\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .xl\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .xl\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .xl\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .xl\\:font-bold {
    font-weight: 700;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;IAAd;;QAAA,wBAAc;QAAd,SAAc;IAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAUnB;IACI,wBAAwB;IACxB,gFAAgF;AACpF;;AAEA;IACI,wBAAwB;AAC5B;;AAGI;EAAA,iBAAoB;EAApB,kBAAoB;EAApB;AAAoB;;AAIpB;EAAA,aAAsC;EAAtC,mBAAsC;EAAtC;AAAsC;;AAItC;EAAA,aAAuC;EAAvC,mBAAuC;EAAvC;AAAuC;;AAG3C;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAGI;EAAA,aAA2C;EAA3C,iBAA2C;EAA3C;AAA2C;;AAG/C,OAAO;AACP,kDAAkD;AAClD,IAAI;;AAGA;EAAA;AAAY;;AAIZ;EAAA;AAAkB;;AAGtB;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAGI;EAAA;AAAkB;;AAGtB;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,2FAA2F;AAC/F;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,YAAY;AAER;EAAA,kBAAgE;EAAhE,wDAAgE;EAAhE,iDAAgE;EAAhE,0DAAgE;EAAhE;AAAgE;;AAIhE;EAAA,kBAAyE;EAAzE,uDAAyE;EAAzE,gDAAyE;EAAzE,0DAAyE;EAAzE;AAAyE;;AAIzE;EAAA,kBAA+D;EAA/D,yDAA+D;EAA/D,kDAA+D;EAA/D,0DAA+D;EAA/D;AAA+D;;AAGnE,YAAY;AAER;EAAA;AAAwB;;AAG5B;IACI,sEAAsE;AAC1E;;AAGI;EAAA,qBAAgG;EAAhG,uBAAgG;EAAhG,iBAAgG;EAAhG,sBAAgG;EAAhG,uDAAgG;EAAhG,oBAAgG;EAAhG;AAAgG;;AAIhG;EAAA,qBAA0E;EAA1E,uBAA0E;EAA1E,kBAA0E;EAA1E,uDAA0E;EAA1E,oBAA0E;EAA1E;AAA0E;;AAI1E;EAAA,qBAAwD;EAAxD,uBAAwD;EAAxD,kBAAwD;EAAxD;AAAwD;;AAIxD;EAAA,qBAAiE;EAAjE,sBAAiE;EAAjE,kBAAiE;EAAjE,sDAAiE;EAAjE,oBAAiE;EAAjE;AAAiE;;AAIjE;EAAA,qBAA8D;EAA9D,uBAA8D;EAA9D,kBAA8D;EAA9D,yDAA8D;EAA9D,oBAA8D;EAA9D;AAA8D;;AAI9D;EAAA,qBAA0E;EAA1E,uBAA0E;EAA1E,iBAA0E;EAA1E,sBAA0E;EAA1E,sDAA0E;EAA1E,oBAA0E;EAA1E;AAA0E;;AAI1E;EAAA,qBAA8D;EAA9D,uBAA8D;EAA9D,kBAA8D;EAA9D,sDAA8D;EAA9D,oBAA8D;EAA9D;AAA8D;;AAI9D;EAAA,qBAA8E;EAA9E,uBAA8E;EAA9E,iBAA8E;EAA9E,sBAA8E;EAA9E,sDAA8E;EAA9E,oBAA8E;EAA9E;AAA8E;;AAI9E;EAAA,qBAA0E;EAA1E,uBAA0E;EAA1E,iBAA0E;EAA1E,sBAA0E;EAA1E,sDAA0E;EAA1E,oBAA0E;EAA1E;AAA0E;;AAI1E;EAAA,qBAA4D;EAA5D,uBAA4D;EAA5D,kBAA4D;EAA5D,sDAA4D;EAA5D,oBAA4D;EAA5D;AAA4D;;AAI5D;EAAA,qBAAuE;EAAvE,uBAAuE;EAAvE,kBAAuE;EAAvE,yDAAuE;EAAvE,oBAAuE;EAAvE;AAAuE;;AAIvE;EAAA,qBAAwE;EAAxE,uBAAwE;EAAxE,iBAAwE;EAAxE,sBAAwE;EAAxE,yDAAwE;EAAxE,oBAAwE;EAAxE;AAAwE;;AAIxE;EAAA,qBAA2D;EAA3D,uBAA2D;EAA3D,kBAA2D;EAA3D,yDAA2D;EAA3D,oBAA2D;EAA3D;AAA2D;;;AAI/D,aAAa;;AAGT;EAAA;AAAU;;AAIV;EAAA;AAAY;;AAIZ;EAAA,sBAAwC;EAAxC,6BAAwC;EAAxC,4BAAwC;EAAxC;AAAwC;;AAIxC;EAAA;AAAY;;AAMZ;;;EAAA,WAAsB;EAAtB,cAAsB;EAAtB;AAAsB;;AAItB;EAAA,uBAAyF;EAAzF,kBAAyF;EAAzF,kBAAyF;EAAzF,yDAAyF;EAAzF,oBAAyF;EAAzF,uBAAyF;EAAzF,oBAAyF;EAAzF,qBAAyF;EAAzF,gBAAyF;EAAzF,oBAAyF;EAAzF;AAAyF;;AAIzF;EAAA;AAAY;;AAIZ;EAAA,sBAAyD;EAAzD,6BAAyD;EAAzD,4BAAyD;EAAzD,6BAAyD;EAAzD,8BAAyD;EAAzD,iCAAyD;EAAzD,yCAAyD;EAAzD;AAAyD;;AAIzD;EAAA,mBAA2B;EAA3B,oBAA2B;EAA3B,oBAA2B;EAA3B;AAA2B;;AAI3B;EAAA;AAA+B;;AAI/B;EAAA;AAAU;;AAIV;EAAA;AAAU;;AAIV;EAAA;AAAY;;AAIZ;EAAA;AAAU;;AAKV;;EAAA,kBAA0K;EAA1K,oBAA0K;EAA1K,kBAA0K;EAA1K;AAA0K;;AAA1K;;EAAA,oBAA0K;EAA1K,kBAA0K;EAA1K,cAA0K;EAA1K,aAA0K;EAA1K,eAA0K;EAA1K,cAA0K;EAA1K,uBAA0K;EAA1K,0BAA0K;EAA1K,kBAA0K;EAA1K;AAA0K;;AAK1K;;EAAA,kBAA8G;EAA9G,cAA8G;EAA9G,iBAA8G;EAA9G,WAA8G;EAA9G,gBAA8G;EAA9G,qBAA8G;EAA9G;AAA8G;;AAI9G;EAAA,kBAAqB;EAArB;AAAqB;;AAIrB;EAAA;AAAe;;AAIf;EAAA,4BAAyB;EAAzB;AAAyB;;AAIzB;EAAA,oBAAsC;EAAtC;AAAsC;;AAItC;EAAA,eAAwB;EAAxB,cAAwB;EAAxB,kBAAwB;EAAxB;AAAwB;;AAIxB;EAAA,uBAAqC;EAArC;AAAqC;;AAIrC;EAAA,sBAA6C;EAA7C,uDAA6C;EAA7C,iCAA6C;EAA7C,yCAA6C;EAA7C;AAA6C;;AAI7C;EAAA,YAAuE;EAAvE,sBAAuE;EAAvE,uBAAuE;EAAvE,gCAAuE;EAAvE,mCAAuE;EAAvE,oBAAuE;EAAvE;AAAuE;;AAAvE;EAAA,mBAAuE;EAAvE;AAAuE;;AAIvE;EAAA,qBAA6F;EAA7F,kBAA6F;EAA7F,yDAA6F;EAA7F,sBAA6F;EAA7F,uBAA6F;EAA7F,qBAA6F;EAA7F,wBAA6F;EAA7F,kBAA6F;EAA7F,iBAA6F;EAA7F,gBAA6F;EAA7F,oBAA6F;EAA7F;AAA6F;;AAI7F;EAAA,sBAA4B;EAA5B,mBAA4B;EAA5B;AAA4B;;;AAIhC,YAAY;AAER;EAAA,iCAAqH;EAArH,mEAAqH;EAArH,6BAAqH;EAArH,mEAAqH;EAArH,+BAAqH;EAArH,wDAAqH;EAArH,wEAAqH;EAArH;AAAqH;;AAIrH;EAAA,+BAAgC;EAAhC;AAAgC;;AAIhC;EAAA,6BAA4B;EAA5B;AAA4B;;AAI5B;EAAA,+BAA8B;EAA9B;AAA8B;;;AAIlC,WAAW;AAEP;EAAA;AAAU;;AAGd;IACI,2BAA2B;IAC3B,uFAAuF;AAC3F;;AAGI;EAAA,WAAiI;EAAjI,gBAAiI;EAAjI,WAAiI;EAAjI,iBAAiI;EAAjI,6BAAiI;EAAjI,YAAiI;EAAjI,iBAAiI;EAAjI,sBAAiI;EAAjI,8BAAiI;EAAjI;AAAiI;;AAAjI;;EAAA;IAAA,cAAiI;IAAjI,iBAAiI;IAAjI;EAAiI;AAAA;;AAIjI;EAAA;AAAa;;AAIb;EAAA,UAAkC;EAAlC,YAAkC;EAAlC;AAAkC;;AAIlC;EAAA,aAA6B;EAA7B;AAA6B;;AAA7B;;EAAA;IAAA;EAA6B;AAAA;;AAI7B;EAAA;AAAoB;;AAApB;;EAAA;IAAA;EAAoB;AAAA;;AAGxB,eAAe;AACf;IACI,iFAAiF;IACjF,YACJ;;AAGI;EAAA,YAA2B;EAA3B,8BAA2B;EAA3B;AAA2B;;AAG/B,UAAU;AAIN;;;EAAA;AAAY;;AAIZ;EAAA,uBAA0F;EAA1F,iBAA0F;EAA1F,sBAA0F;EAA1F,yDAA0F;EAA1F,kBAA0F;EAA1F,yDAA0F;EAA1F,qBAA0F;EAA1F,wBAA0F;EAA1F,qBAA0F;EAA1F,sBAA0F;EAA1F,sBAA0F;EAA1F,8BAA0F;EAA1F;AAA0F;;AAI1F;EAAA;AAAe;;AAIf;EAAA;AAAS;;AAIT;EAAA;AAAe;;AAIf;EAAA,kBAA0C;EAA1C,kBAA0C;EAA1C;AAA0C;;AAI1C;EAAA,kBAAmB;EAAnB;AAAmB;;AAInB;EAAA,eAAwC;EAAxC,kBAAwC;EAAxC;AAAwC;;AAG5C,eAAe;AAEX;EAAA,qBAAgC;EAAhC;AAAgC;;AAGpC,UAAU;AACV;IACI,wBAAwB;IACxB,iBAA4B;IAA5B,mBAA4B;IAA5B,oBAA4B;IAA5B,cACJ;;AAGI;EAAA;AAAc;;AAGlB,2BAA2B;AAEvB;EAAA;AAAqB;;AAIrB;EAAA,4BAAyB;EAAzB;AAAyB;;AAIzB;EAAA,WAAiC;EAAjC,WAAiC;EAAjC,gBAAiC;EAAjC;AAAiC;;AAGrC,qBAAqB;AAEjB;EAAA,uBAAmE;EAAnE,kBAAmE;EAAnE,yDAAmE;EAAnE,oBAAmE;EAAnE,uBAAmE;EAAnE,oBAAmE;EAAnE;AAAmE;;AAGvE,cAAc;AAEV;EAAA,+BAAoC;EAApC;AAAoC;;AAIpC;EAAA,6BAAkC;EAAlC;AAAkC;;AAIlC;EAAA,6BAAuC;EAAvC;AAAuC;;AAIvC;EAAA,iCAAsC;EAAtC;AAAsC;;AAG1C;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAGI;EAAA;AAAkB;;AAGtB;IAEQ;IAAA,gBAAiC;IAAjC,sBAAiC;IAAjC;EAAiC;;IAIjC;IAAA,sBAAmB;IAAnB;EAAmB;AAE3B;;AAEA;IAEQ;IAAA,iBAAyB;IAAzB,qBAAyB;IAAzB;EAAyB;AAEjC;;AAjcA;EAAA,mBAkcA;EAlcA;AAkcA;;AAlcA;EAAA;AAkcA;;AAlcA;EAAA,oBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,oBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,0BAkcA;EAlcA;AAkcA;;AAlcA;EAAA,0BAkcA;EAlcA;AAkcA;;AAlcA;EAAA,0BAkcA;EAlcA;AAkcA;;AAlcA;EAAA,0BAkcA;EAlcA;AAkcA;;AAlcA;EAAA,0BAkcA;EAlcA;AAkcA;;AAlcA;EAAA,0BAkcA;EAlcA;AAkcA;;AAlcA;EAAA,0BAkcA;EAlcA,kBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,0BAkcA;EAlcA,kBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,0BAkcA;EAlcA,kBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,0BAkcA;EAlcA;AAkcA;;AAlcA;EAAA;AAkcA;;AAlcA;EAAA;AAkcA;;AAlcA;EAAA;AAkcA;;AAlcA;EAAA;AAkcA;;AAlcA;EAAA;AAkcA;;AAlcA;EAAA,oCAkcA;EAlcA;AAkcA;;AAlcA;EAAA,sBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,sBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,sBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,sBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,sBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,sBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,kBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,kBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,kBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,kBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,kBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,kBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,oBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,oBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,oBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,oBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,oBAkcA;EAlcA;AAkcA;;AAlcA;EAAA;AAkcA;;AAlcA;EAAA;AAkcA;;AAlcA;EAAA,sBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,8BAkcA;EAlcA;AAkcA;;AAlcA;EAAA;AAkcA;;AAlcA;EAAA;AAkcA;;AAlcA;EAAA;AAkcA;;AAlcA;EAAA,oCAkcA;EAlcA;AAkcA;;AAlcA;EAAA,sBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,sBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,kBAkcA;EAlcA;AAkcA;;AAlcA;EAAA;AAkcA;;AAlcA;EAAA,oBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,oBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,oBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,oBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,oBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,0BAkcA;EAlcA,wBAkcA;EAlcA;AAkcA;;AAlcA;EAAA,gDAkcA;EAlcA,6DAkcA;EAlcA;AAkcA;;AAlcA;;EAAA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA,oBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,kBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,oBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,oBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,kBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,sBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,oBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,kBAkcA;IAlcA;EAkcA;AAAA;;AAlcA;;EAAA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA,kBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,gBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,oBAkcA;IAlcA;EAkcA;AAAA;;AAlcA;;EAAA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;AAAA;;AAlcA;;EAAA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA,gBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,mBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,eAkcA;IAlcA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA,uBAkcA;IAlcA,2DAkcA;IAlcA;EAkcA;;EAlcA;IAAA,uBAkcA;IAlcA,8DAkcA;IAlcA;EAkcA;;EAlcA;IAAA,uBAkcA;IAlcA,gEAkcA;IAlcA;EAkcA;;EAlcA;IAAA,uBAkcA;IAlcA,+DAkcA;IAlcA;EAkcA;;EAlcA;IAAA,uBAkcA;IAlcA,gEAkcA;IAlcA;EAkcA;;EAlcA;IAAA,uBAkcA;IAlcA,4DAkcA;IAlcA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA,+BAkcA;IAlcA;EAkcA;;EAlcA;IAAA,8BAkcA;IAlcA;EAkcA;;EAlcA;IAAA,+BAkcA;IAlcA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA,sBAkcA;IAlcA,6DAkcA;IAlcA;EAkcA;;EAlcA;IAAA,sBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,sBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,kBAkcA;IAlcA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,sBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,oBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,kBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,oBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,sBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,sBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,kBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,oBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,sBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,oBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,mBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,oBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,iBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,iBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,qBAkcA;IAlcA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA;EAkcA;;EAlcA;IAAA,eAkcA;IAlcA;EAkcA;;EAlcA;IAAA,mBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,mBAkcA;IAlcA;EAkcA;;EAlcA;IAAA,kBAkcA;IAlcA;EAkcA;;EAlcA;IAAA;EAkcA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n    input[type=\"number\"]::-webkit-inner-spin-button,\n    input[type=\"number\"]::-webkit-outer-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n    }\n}\n\n@font-face {\n    font-family: \"YekanBakh\";\n    src: local(\"YekanBakh\"), url(\"../fonts/YekanBakhFaNum-VF.woff2\") format('woff2');\n}\n\nhtml {\n    font-family: \"YekanBakh\";\n}\n\n.container {\n    @apply w-full mx-auto\n}\n\n.flex-center {\n    @apply flex items-center justify-center\n}\n\n.flex-between {\n    @apply flex items-center justify-between\n}\n\n.rtl {\n    direction: rtl;\n}\n\n.ltr {\n    direction: ltr;\n}\n\n.block-scroll {\n    @apply overflow-hidden h-screen max-h-screen\n}\n\n/*.a {*/\n/*    padding-bottom: env(safe-area-inset-bottom)*/\n/*}*/\n\n.scroll-none::-webkit-scrollbar {\n    @apply hidden\n}\n\n.pol-scroll::-webkit-scrollbar {\n    @apply w-[0.438rem]\n}\n\n.pol-scroll::-webkit-scrollbar-track {\n    border-radius: 15px;\n    background: #f1f1f1;\n}\n\n.pol-scroll::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 15px;\n}\n\n.pol-scroll::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n\n.pol-purple-scroll::-webkit-scrollbar {\n    @apply w-[0.438rem]\n}\n\n.pol-purple-scroll::-webkit-scrollbar-track {\n    border-radius: 30px;\n    background: rgb(203, 195, 224);\n    background: linear-gradient(0deg, rgba(203, 195, 224, 0.4) 0%, rgba(203, 195, 224, 0) 100%);\n}\n\n.pol-purple-scroll::-webkit-scrollbar-thumb {\n    background: #CBC3E0;\n    border-radius: 30px;\n}\n\n.pol-purple-scroll::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n\n/* Shadows */\n.notify-shadow-green {\n    @apply bg-pol-green shadow-[0_3px_12px_4px_rgba(90,234,191,0.47)]\n}\n\n.notify-shadow-orange {\n    @apply bg-pol-main-dark-color shadow-[0_3px_12px_4px_rgba(255,182,0,0.47)]\n}\n\n.notify-shadow-red {\n    @apply bg-pol-red shadow-[0_3px_12px_4px_rgba(255,117,117,0.47)]\n}\n\n/* Buttons */\nbutton[disabled=\"disabled\"], button[diabled] {\n    @apply cursor-not-allowed\n}\n\n.btn-main-outline {\n    /*@apply inline-block rounded-xl text-pol-blue border border-pol-blue*/\n}\n\n.btn-outline-dark-orange {\n    @apply inline-block rounded-[0.688rem] text-pol-main-dark-color border border-pol-main-dark-color\n}\n\n.btn-orange {\n    @apply inline-block rounded-[0.688rem] bg-pol-main-dark-color text-pol-dark\n}\n\n.btn-main-purple {\n    @apply inline-block rounded-[0.688rem] bg-pol-main-purple\n}\n\n.btn-main-dark {\n    @apply inline-block rounded-xl text-pol-light-purple-2 bg-pol-dark\n}\n\n.btn-purple {\n    @apply inline-block rounded-[0.688rem] bg-pol-purple text-white\n}\n\n.btn-outline-main-dark {\n    @apply inline-block rounded-[0.688rem] text-pol-dark border border-pol-dark\n}\n\n.btn-dark {\n    @apply inline-block rounded-[0.688rem] text-white bg-pol-dark-2\n}\n\n.btn-outline-dark {\n    @apply inline-block rounded-[0.688rem] text-pol-dark-2 border border-pol-dark-2\n}\n\n.btn-outline-gray {\n    @apply inline-block rounded-[0.688rem] text-pol-gray border border-pol-gray\n}\n\n.btn-gray {\n    @apply inline-block rounded-[0.688rem] text-white bg-pol-gray\n}\n\n.btn-light-gray {\n    @apply inline-block rounded-[0.688rem] text-pol-purple bg-pol-light-gray\n}\n\n.btn-outline-red {\n    @apply inline-block rounded-[0.688rem] text-pol-red border border-pol-red\n}\n\n.btn-red {\n    @apply inline-block rounded-[0.688rem] text-white bg-pol-red\n}\n\n\n/* Dropdown */\n\n.pol-dropdown-tree .infinite-scroll-component {\n    @apply pb-8\n}\n\n.pol-dropdown-tree .dropdown {\n    @apply w-full\n}\n\n.pol-dropdown-tree .dropdown-trigger {\n    @apply w-full border-none px-0 !important\n}\n\n.pol-dropdown-tree .dropdown-trigger .tag-list .tag-item span.tag {\n    @apply hidden\n}\n\n.pol-dropdown-tree .dropdown-trigger .tag-list,\n.pol-dropdown-tree .dropdown-trigger .tag-list .tag-item,\n.pol-dropdown-tree .dropdown-trigger .tag-list .tag-item input {\n    @apply block w-full m-0\n}\n\n.pol-dropdown-tree .dropdown-trigger .tag-list .tag-item input {\n    @apply bg-[#F7F7F7] py-3 px-2 rounded-[0.625rem] border-none text-pol-purple font-semibold\n}\n\n.pol-dropdown-tree .dropdown-trigger:after {\n    @apply hidden\n}\n\n.pol-dropdown-tree .dropdown-content {\n    @apply w-full shadow-none px-0 pb-0 border-none !important\n}\n\n.pol-dropdown-tree .dropdown-content .node {\n    @apply text-sm text-pol-dark\n}\n\n.pol-dropdown-tree .dropdown-content .node.focused {\n    @apply bg-transparent !important\n}\n\n.pol-dropdown-tree .dropdown-content .node.leaf {\n    @apply pr-4\n}\n\n.pol-dropdown-tree .dropdown-content .node.leaf[aria-level=\"1\"] {\n    @apply pr-0\n}\n\n.pol-dropdown-tree .dropdown-content .node.leaf[aria-level=\"1\"] > i {\n    @apply hidden\n}\n\n.pol-dropdown-tree .dropdown-content .node.leaf:last-child {\n    @apply mb-3\n}\n\n.pol-dropdown-tree .dropdown-content .node.tree label input.checkbox-item,\n.pol-dropdown-tree .dropdown-content .node.leaf label input.checkbox-item {\n    @apply bg-pol-main-purple ml-3 relative after:w-5 after:h-5 after:rounded-[0.313rem] after:bg-[#EFEFF2] after:absolute after:pointer-events-none after:-left-1 after:-top-1\n}\n\n.pol-dropdown-tree .dropdown-content .node.tree label input:checked.checkbox-item,\n.pol-dropdown-tree .dropdown-content .node.leaf label input:checked.checkbox-item {\n    @apply before:content-['\\2713'] before:absolute before:z-10 before:font-bold before:left-0.5 before:-bottom-1.5\n}\n\n.pol-dropdown-tree .dropdown-content .node.tree i {\n    @apply absolute left-0\n}\n\n.pol-dropdown-tree .dropdown-content .node.tree i.toggle {\n    @apply opacity-0\n}\n\n.pol-dropdown-tree .dropdown-content .node.tree[aria-expanded=\"true\"] i:not(.toggle) {\n    @apply rotate-0 !important\n}\n\n.pol-dropdown-tree .dropdown-content .node.tree i:not(.toggle) {\n    @apply pointer-events-none duration-200\n}\n\n.pol-dropdown-tree .icon-simple-arrow-left {\n    @apply bg-pol-red w-3 h-1\n}\n\n.pol-tag-input .rti--container {\n    @apply rounded-[0.875rem] duration-300\n}\n\n.pol-tag-input .rti--container:focus-within {\n    @apply !shadow-none border-pol-main-dark-color\n}\n\n.pol-tag-input .rti--input {\n    @apply flex-grow px-3.5 !py-[0.188rem] text-pol-gray placeholder:text-sm\n}\n\n.pol-tag-input .rti--tag {\n    @apply bg-pol-light-gray-3 text-xs font-semibold text-pol-gray px-2.5 py-[0.313rem] rounded-lg\n}\n\n.pol-tag-input .rti--tag button {\n    @apply p-0 mr-[1.625rem] mt-1\n}\n\n\n/* Globals */\n.sidebar-links .active div {\n    @apply border-pol-main-color bg-pol-main-color drop-shadow-[0_6px_12px_rgba(255,182,0,0.3)] text-pol-dark-2 !important\n}\n\n.sidebar-links .active span {\n    @apply text-pol-dark-2 !important\n}\n\n.sidebar-links .sub-active div {\n    @apply bg-pol-dark !important\n}\n\n.sidebar-links .sub-active span {\n    @apply text-pol-dark !important\n}\n\n\n/* Modals */\n.pol-simple-modal .react-responsive-modal-container {\n    @apply pt-5\n}\n\n.pol-simple-modal .react-responsive-modal-overlay {\n    background: rgb(50, 46, 62);\n    background: linear-gradient(225deg, rgba(50, 46, 62, 0.8) 0%, rgba(50, 46, 62, 1) 100%);\n}\n\n.pol-simple-modal .react-responsive-modal-modal {\n    @apply bg-transparent shadow-none text-right overflow-visible w-full lg:w-auto m-0 lg:m-[1.2rem] p-0 min-h-[65vh] lg:min-h-[unset]\n}\n\n.pol-simple-modal.center .react-responsive-modal-modal {\n    @apply !m-auto\n}\n\n.pol-simple-modal .react-responsive-modal-closeButton {\n    @apply left-4 -top-10 right-[unset]\n}\n\n.pol-simple-modal .react-responsive-modal-container {\n    @apply flex items-end lg:block\n}\n\n.pol-simple-modal .react-responsive-modal-closeButton {\n    @apply hidden lg:flex\n}\n\n/*Spring modal*/\n.pol-bottom-sheet div[data-rsbs-backdrop] {\n    background: linear-gradient(222deg, rgba(50,46,62,0.8) 0%, rgba(50,46,62,1) 100%);\n    @apply z-[100]\n}\n\n.pol-bottom-sheet div[data-rsbs-overlay] {\n    @apply z-[110] rounded-t-3xl\n}\n\n/* Audio */\n.pol-audio-container .rhap_volume-bar-area,\n.pol-audio-container .rhap_time,\n.pol-audio-container .rhap_progress-indicator {\n    @apply hidden\n}\n\n.pol-audio-container .rhap_container {\n    @apply py-0.5 px-3 bg-pol-light rounded-[0.688rem] border border-pol-light-gray shadow-none\n}\n\n.pol-audio-container .rhap_controls-section {\n    @apply flex-none\n}\n\n.pol-audio-container .rhap_play-pause-button {\n    @apply w-5\n}\n\n.pol-audio-container .rhap_volume-container {\n    @apply flex-none\n}\n\n.pol-audio-container .rhap_progress-filled {\n    @apply bg-pol-main-dark-color rounded-[3px]\n}\n\n.pol-audio-container .rhap_download-progress {\n    @apply bg-pol-purple\n}\n\n.pol-audio-container .rhap_progress-bar-show-download {\n    @apply bg-pol-purple/60 h-1 rounded-[3px]\n}\n\n/* Guide modal*/\n.guide-content a {\n    @apply font-semibold inline-block\n}\n\n/* Toast */\n.Toastify__toast .Toastify__toast-body {\n    font-family: \"YekanBakh\";\n    @apply text-right text-sm rtl\n}\n\n.Toastify__toast-container--top-right {\n    @apply !right-0\n}\n\n/*Pol single dropdown tree*/\n.pol-single-dropdown-tree button.collapsed-node {\n    @apply mb-0 !important\n}\n\n.pol-single-dropdown-tree button.collapsed-node i {\n    @apply rotate-0 !important\n}\n\n.pol-single-dropdown-tree ul.sub-list.collapsed {\n    @apply h-0 overflow-hidden p-0 m-0\n}\n\n/* Transaction Page */\n.transaction-data .active-filter {\n    @apply bg-pol-light-orange-2 py-1 rounded-[0.438rem] text-pol-dark-2\n}\n\n/*Date picker*/\n.rmdp-week-day, .rmdp-action-button {\n    @apply text-pol-main-color !important\n}\n\n.rmdp-day:not(.rmdp-disabled,.rmdp-day-hidden) span:hover {\n    @apply bg-pol-main-color !important\n}\n\n.rmdp-day.rmdp-selected span:not(.highlight) {\n    @apply bg-pol-main-dark-color !important\n}\n\n.rmdp-arrow {\n    @apply border-pol-main-color !important\n}\n\n.ticket-message-container ol, .ticket-message-container ul {\n    padding-right: 40px;\n}\n\n.ticket-message-container ol {\n    list-style-type: decimal;\n}\n\n.ticket-message-container ul {\n    list-style-type: disc;\n}\n\n.ticket-message-container span {\n    @apply inline-block\n}\n\n@media screen and (max-width: 1279px) {\n    .container {\n        @apply max-w-[850px] px-[0.938rem]\n    }\n\n    .m-padding-x {\n        @apply px-[0.938rem]\n    }\n}\n\n@media screen and (min-width: 1280px) {\n    .container {\n        @apply max-w-[1440px] px-7\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
